import { FORM_SCHEDULE_STATUS, FORM_TYPES } from '@/components/stores/constants/constants.stores'
import { SCHEDULES_STORE_NAMES } from '@/db/constants'
import { generateDayUniqueId, getDateNow } from '@/utils/basicUtils'
import { isWeb } from '@/utils/platformUtils'
import { getDb, yieldToUI } from '../adapter'
import { TABLE_NAME } from '../constants/tables'

export interface Campaing {
    _id: string
    name: string
    code: string
    prefix: string
    image: string
    date_init: Date
    date_finish: Date
    date_moderation_init: Date
    date_moderation_finish: Date
    moderation: boolean
    steps: Step[]
    total_progres: number
    values: Value[]
    pos: any[]
    schedule_free: boolean
    schedules: Schedule[]
    status: number
    _v: number
}

export interface Schedule {
    _id: string
    date_finish: Date
    date_init: Date
    progress_diary: boolean
    activities: any[]
    vacation: boolean
    others_activities: any[]
    additional: Additional
    form_init: string
    form_finish: string
    activities_advances: null
    others_activities_advances: null
    forms_additionals: any[]
    forms_incidence: null
    reports: Additional
    data_version: number
    history_forms: any[]
}

export interface Additional {}

export interface Step {
    name: string
    code: string
    prefix: string
    image: string
    date_init: Date
    date_finish: Date
    type: string
    forms: Form[]
    checkins?: number | null
    forms_objetive?: FormsObjetive[]
}

export interface Form {
    _id: string
    status: number
}

export interface FormsObjetive {
    form_id: number
    count: number
}

export interface Value {
    label: string
    value: number
    color_hex: string
}

interface SaveFormAnswersResult {
    end: 'saveFormAnswers'
    result: any | null
    message: string
}

// TIP: tipá mejor este form según tu modelo real
type SaveFormInput = any

export async function saveFormAnswers(form: SaveFormInput): Promise<SaveFormAnswersResult> {
    const {
        schedule_id,
        form_id,
        store_id,
        repeat,
        questions,
        progress,
        totalScore,
        answers = '[]',
        status,
        type_form,
        checkin_id,
        day_unique_id: providedDayId, // ✅ FIX #3: Aceptar day_unique_id del formulario
    } = form

    // 🚨 DEBUG: Log para detectar llamadas problemáticas
    if (answers === '[]' && status && parseInt(status) === 5) {
        // console.log('🚨 ALERT: saveFormAnswers called with empty answers and completed status')
        // console.log('📋 Form details:', { form_id, schedule_id, store_id, status, answersLength: JSON.parse(answers).length })
    }

    // Si no hay preguntas y no es redirect, no hacemos nada
    if (JSON.parse(questions).length === 0 && type_form?.type !== FORM_TYPES.FORM_REDIRECT) {
        return {
            end: 'saveFormAnswers',
            result: null,
            message: 'Form sin preguntas, no se crea registro',
        }
    }

    const { cantQuestionPonderar, scoreTotalQuestionsPonderar } = getCantQuestionPonderar(questions)

    const date_init = getDateNow()
    const date_finish = ''
    // ✅ FIX #3: Usar day_unique_id provisto (generado al abrir form) o generar nuevo
    const generateIdDate = providedDayId || generateDayUniqueId()

    // ✅ FIX: Validar que form_id_father no sea '0' ni string vacío
    const sanitizedFormIdFather = form.form_id_father && form.form_id_father !== '' && form.form_id_father !== '0' ? form.form_id_father : null

    if (isWeb()) {
        // TODO: implementar versión web (IndexedDB, etc.)
        // Por ahora puedes lanzar error o devolver un mensaje
        return {
            end: 'saveFormAnswers',
            result: null,
            message: 'saveFormAnswers web no implementado aún',
        }
    }

    const db = await getDb()

    const response = await db.transaction<SaveFormAnswersResult>(async (txn) => {
        // 1) Primero veo si ya existe un registro compatible

        let selectSql = ''
        let selectParams: any[] = []

        if (store_id) {
            if (repeat === 1) {
                selectSql = `
                    SELECT *
                    FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                    WHERE schedule_id = ?
                        AND form_id = ?
                        AND store_id = ?
                        AND status NOT IN (?, ?);
                `
                selectParams = [schedule_id, form_id, store_id, FORM_SCHEDULE_STATUS.COMPLETED, FORM_SCHEDULE_STATUS.PENDING_CONNECTION]
            } else {
                selectSql = `
                    SELECT *
                    FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                    WHERE schedule_id = ?
                        AND form_id = ?
                        AND store_id = ?
                        AND day_unique_id = ?;
                `
                selectParams = [schedule_id, form_id, store_id, generateIdDate]
            }
        } else {
            selectSql = `
                SELECT *
                FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                WHERE schedule_id = ?
                AND form_id = ?
                AND day_unique_id = ?
                AND status NOT IN (?, ?);
            `
            selectParams = [schedule_id, form_id, generateIdDate, FORM_SCHEDULE_STATUS.COMPLETED, FORM_SCHEDULE_STATUS.PENDING_CONNECTION]
        }

        const existingRows = await txn.getAll<any>({
            sql: selectSql,
            params: selectParams,
        })

        const isExists = validateDateRegister(existingRows)

        // 2) Si NO existe → inserto registro nuevo

        if (!isExists) {
            let insertSql = ''
            let insertParams: any[] = []

            console.log('🚨 Inserting new form answers record store_id => ', store_id)
            if (store_id) {
                insertSql = `
                    INSERT INTO ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} (
                        repeat,
                        date_init,
                        date_finish,
                        schedule_id,
                        form_id,
                        store_id,
                        status,
                        answers,
                        questions,
                        progress,
                        totalScore,
                        scoreObtainedFloat,
                        cant_questions_yes_na,
                        progress_questions_yes_na,
                        scoreTotalQuestionsPonderarFloat,
                        name_form,
                        heladera,
                        create_refrigerator,
                        type_form,
                        form_id_father,
                        checkout,
                        day_unique_id,
                        checkin_id
                    ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);
                `

                insertParams = [
                    repeat,
                    date_init,
                    date_finish,
                    schedule_id,
                    form_id,
                    store_id,
                    status,
                    answers,
                    questions,
                    progress,
                    totalScore,
                    form.scoreObtained,
                    cantQuestionPonderar,
                    form.progress_questions_yes_na,
                    scoreTotalQuestionsPonderar,
                    form.name_form,
                    form.heladera,
                    form.create_refrigerator,
                    JSON.stringify(form.type_form),
                    sanitizedFormIdFather,
                    form.checkout,
                    generateIdDate,
                    checkin_id,
                ]
            } else {
                insertSql = `
                    INSERT INTO ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} (
                        repeat,
                        date_init,
                        schedule_id,
                        form_id,
                        store_id,
                        status,
                        answers,
                        questions,
                        progress,
                        totalScore,
                        scoreObtainedFloat,
                        cant_questions_yes_na,
                        progress_questions_yes_na,
                        scoreTotalQuestionsPonderarFloat,
                        name_form,
                        heladera,
                        create_refrigerator,
                        type_form,
                        form_id_father,
                        day_unique_id,
                        checkin_id
                    ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);
                `

                insertParams = [
                    repeat,
                    date_init,
                    schedule_id,
                    form_id,
                    '',
                    status,
                    answers,
                    questions,
                    progress,
                    totalScore,
                    0,
                    cantQuestionPonderar,
                    0,
                    scoreTotalQuestionsPonderar,
                    form.name_form,
                    form.heladera,
                    form.create_refrigerator,
                    JSON.stringify(form.type_form),
                    sanitizedFormIdFather,
                    generateIdDate,
                    checkin_id,
                ]
            }

            console.log('insertParams saveFormAnswers:')
            // insertParams.forEach((v, i) => {
            //     console.log(i, '=>', v, 'typeof:', typeof v)
            // })
            // console.log('🚨 insertParams =>', insertParams)
            // console.log('🚨 insertSql =>', insertSql)

            const insertResult = await txn.run({ sql: insertSql, params: insertParams })

            console.log('🚨 Inserted new form answers record successfully')

            // ✅ OPTIMIZACIÓN: Buscar el registro recién creado usando el _id devuelto por el INSERT
            // Esto es 100% confiable porque usa la clave primaria exacta
            const createdRecord = await txn.getFirst<any>({
                sql: `SELECT * FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} WHERE _id = ?`,
                params: [insertResult.lastInsertRowId],
            })

            // console.log('🚨 Created record fetched:', createdRecord)

            if (createdRecord) {
                return {
                    end: 'saveFormAnswers',
                    result: createdRecord,
                    message: 'Agrego el registro con éxito: saveFormAnswers',
                }
            }

            // Este caso no debería ocurrir nunca si el INSERT fue exitoso
            return {
                end: 'saveFormAnswers',
                result: null,
                message: 'saveFormAnswers: quiero devolver el registro creado pero no se encontró..',
            }
        }

        // 3) Si YA existe → leo el registro actual y decido si updatear o no
        let getSql = ''
        let getParams: any[] = []

        if (store_id) {
            getSql = `
                SELECT *
                FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                WHERE schedule_id = ?
                AND form_id = ?
                AND store_id = ?
                AND day_unique_id = ?;
            `
            getParams = [schedule_id, form_id, store_id, generateIdDate]
        } else {
            getSql = `
                SELECT *
                FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
                WHERE schedule_id = ?
                AND form_id = ?
                AND day_unique_id = ?;
            `
            getParams = [schedule_id, form_id, generateIdDate]
        }

        const existingRecord = await txn.getFirst<any>({ sql: getSql, params: getParams })

        if (!existingRecord) {
            return {
                end: 'saveFormAnswers',
                result: null,
                message: 'saveFormAnswers: quiero devolver el registro que ya existe pero no se encontró..',
            }
        }

        const existingAnswers = JSON.parse(existingRecord.answers || '[]')
        const newAnswers = JSON.parse(answers || '[]')

        const newStatus = status !== undefined && status !== null ? parseInt(status, 10) : status
        const existingStatus =
            existingRecord.status !== undefined && existingRecord.status !== null ? parseInt(existingRecord.status, 10) : existingRecord.status

        let needsUpdate = false

        // Comparar la clave moderation dentro de answers
        for (let i = 0; i < newAnswers.length; i++) {
            const newAnswer = newAnswers[i]
            const existingAnswer = existingAnswers.find((ans: any) => ans._id === newAnswer._id)
            if (existingAnswer) {
                if (JSON.stringify(existingAnswer.moderation) !== JSON.stringify(newAnswer.moderation)) {
                    needsUpdate = true
                    break
                }
            } else {
                needsUpdate = true
                break
            }
        }

        if (status && existingStatus !== newStatus) {
            needsUpdate = true
        }

        if (!needsUpdate) {
            return {
                end: 'saveFormAnswers',
                result: existingRecord,
                message: 'El registro ya existe y no se necesita actualizar',
            }
        }

        // 🚨 VALIDACIÓN: No sobrescribir respuestas existentes con array vacío
        let answersToUpdate = newAnswers
        if (newAnswers.length === 0 && existingAnswers.length > 0) {
            answersToUpdate = existingAnswers
        }

        let updateSql = `
            UPDATE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS}
            SET answers = ?
        `
        const updateParams: any[] = [JSON.stringify(answersToUpdate), questions]

        // Actualizar campos de heladera si existen en form
        if (form.heladera !== undefined && form.heladera !== null) {
            updateSql += `, heladera = ?`
            updateParams.push(form.heladera)
        }

        if (form.form_id_father !== undefined && form.form_id_father !== null) {
            updateSql += `, form_id_father = ?`
            updateParams.push(form.form_id_father)
        }

        if (form.create_refrigerator !== undefined && form.create_refrigerator !== null) {
            updateSql += `, create_refrigerator = ?`
            updateParams.push(form.create_refrigerator)
        }

        if (form.type_form !== undefined && form.type_form !== null) {
            updateSql += `, type_form = ?`
            updateParams.push(JSON.stringify(form.type_form))
        }

        if (form.name_form !== undefined && form.name_form !== null) {
            updateSql += `, name_form = ?`
            updateParams.push(form.name_form)
        }

        if (status) {
            updateSql += `, status = ?`
            updateParams.push(newStatus)
        }

        updateSql += ` WHERE schedule_id = ? AND form_id = ?`
        updateParams.push(schedule_id, form_id)

        if (store_id) {
            updateSql += ` AND store_id = ?`
            updateParams.push(store_id)
        }

        if (generateIdDate) {
            updateSql += ` AND day_unique_id = ?`
            updateParams.push(generateIdDate)
        }

        updateSql += `;`

        console.log('✅ saveFormAnswers UPDATE con campos:', {
            heladera: form.heladera,
            form_id_father: form.form_id_father,
            create_refrigerator: form.create_refrigerator,
        })

        await txn.run({ sql: updateSql, params: updateParams })

        const updatedRecord = await txn.getFirst<any>({
            sql: getSql,
            params: getParams,
        })

        console.log('🚨 Updated record:', updatedRecord)

        if (!updatedRecord) {
            throw new Error('No se pudo obtener el registro actualizado')
        }

        return {
            end: 'saveFormAnswers',
            result: updatedRecord,
            message: 'Registro actualizado con éxito',
        }
    })

    return response
}

export async function testInsert() {
    const db = await getDb()
    try {
        // await db.run({
        //     sql: `
        //     INSERT INTO form_question_answers (
        //       repeat,
        //       date_init,
        //       schedule_id,
        //       form_id,
        //       store_id,
        //       status,
        //       answers,
        //       questions,
        //       progress,
        //       totalScore,
        //       scoreObtainedFloat,
        //       cant_questions_yes_na,
        //       progress_questions_yes_na,
        //       scoreTotalQuestionsPonderarFloat,
        //       name_form,
        //       heladera,
        //       create_refrigerator,
        //       type_form,
        //       form_id_father,
        //       day_unique_id,
        //       checkin_id
        //     ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);
        //   `,
        //     params: [
        //         null,
        //         '2025-12-01T14:11:19.406Z',
        //         '',
        //         '691f5d8c4b087e7c3279b464',
        //         '',
        //         0,
        //         '[]',
        //         '[{...}]', // podés reducirlo a algo corto para probar
        //         null,
        //         null,
        //         0,
        //         0,
        //         0,
        //         0,
        //         null,
        //         null,
        //         null,
        //         '{"_id":"6840a52c..."}',
        //         null,
        //         '251201',
        //         null,
        //     ],
        // })

        await db.run({
            sql: `
    INSERT INTO form_question_answers (
      repeat,
      date_init,
      schedule_id,
      form_id,
      store_id,
      status,
      answers,
      questions,
      progress,
      totalScore,
            scoreObtainedFloat,
            scoresByKey,
            totalByKey,
      cant_questions_yes_na,
      progress_questions_yes_na,
      scoreTotalQuestionsPonderarFloat,
      name_form,
      heladera,
      create_refrigerator,
      type_form,
      form_id_father,
      day_unique_id,
      checkin_id
    ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?);
  `,
            params: [
                0, // repeat   ← antes null
                '2025-12-01T14:11:19.406Z', // date_init
                '', // schedule_id
                '691f5d8c4b087e7c3279b464', // form_id
                '', // store_id
                0, // status
                '[]', // answers
                '[{...}]', // questions
                0, // progress    ← antes null
                0, // totalScore  ← antes null
                0, // scoreObtainedFloat
                    JSON.stringify({}), // scoresByKey
                    JSON.stringify({}), // totalByKey
                0, // cant_questions_yes_na
                0, // progress_questions_yes_na
                0, // scoreTotalQuestionsPonderarFloat
                '', // name_form   ← antes null
                0, // heladera    ← antes null
                0, // create_refrigerator ← antes null
                '{"_id":"6840a52c..."}', // type_form
                '', // form_id_father ← antes null
                '251201', // day_unique_id
                '', // checkin_id  ← antes null
            ],
        })

        console.error('Insert realizado con éxito')
    } catch (error) {
        console.error('Error en testInsert:', error)
    }

    try {
        const cols = await db.getAll({
            sql: 'PRAGMA table_info(form_question_answers);',
        })
        console.log('TABLE INFO:', cols)
    } catch (error) {
        console.error('Error obteniendo table_info:', error)
    }

    try {
        const schema = await db.getFirst({
            sql: `
    SELECT sql
    FROM sqlite_master
    WHERE type='table' AND name='form_question_answers';
    `,
        })
        console.log('SCHEMA:', schema)
    } catch (error) {
        console.error('Error obteniendo schema:', error)
    }
}

/**
 *
 * @param {*} questions
 * @returns {{cantQuestionPonderar<number> ; scoreTotalQuestionsPonderar<number>}}
 */
const getCantQuestionPonderar = (questions) => {
    const questionsTransform = JSON.parse(questions)
    const cantQuestionPonderar = questionsTransform.filter((obj) => obj.ponderar === true)
    const scoreTotalQuestionsPonderar = cantQuestionPonderar.reduce((accumulator, currentValue) => {
        const questionScore = currentValue.questionScore ?? 0
        const score = currentValue.score ?? 0
        return accumulator + questionScore + score
    }, 0)

    return {
        scoreTotalQuestionsPonderar,
        cantQuestionPonderar: cantQuestionPonderar.length,
    }
}

/**
 * @description valida si existe un registro, si existe true, sino existe false
 * @param {@} registersExistent
 * @returns
 */
const validateDateRegister = (registersExistent) => {
    let isExists = false
    if (!registersExistent || registersExistent.length === 0) {
        return isExists
    }

    const today = new Date().toISOString().split('T')[0]
    // console.log('2registersExistent => today =>', today, registersExistent)
    for (let i = 0; i < registersExistent.length; i++) {
        const row = registersExistent[i]
        if (row.date_init && row.date_init.split('T')[0] === today) {
            isExists = true
            break
        }
    }

    return isExists
}

/**
 * @description Obtiene la información de existencia en DB de una tienda
 * @param store_id ID de la tienda
 * @returns Promise con existsInDB y _id_mongoDB
 */
export async function getExistsInDB(store_id: string): Promise<{ existsInDB: number; _id_mongoDB: string | null }> {
    if (isWeb()) {
        throw new Error('getExistsInDB no está implementado para web')
    }

    const db = await getDb()

    const result = await db.getFirst<{ existsInDB: number; _id_mongoDB: string | null }>({
        sql: `SELECT existsInDB, _id_mongoDB FROM ${SCHEDULES_STORE_NAMES.STORES} WHERE _id = ?;`,
        params: [store_id],
    })

    if (!result) {
        throw new Error(`No se encontró la tienda con _id: ${store_id}`)
    }

    return {
        existsInDB: result.existsInDB,
        _id_mongoDB: result._id_mongoDB,
    }
}

/**
 * @description Inserta o actualiza una campaña en la base de datos
 * @param campaing Objeto con los datos de la campaña
 * @returns Promise<void>
 */
export async function addCampaing(campaing: Campaing): Promise<void> {
    if (isWeb()) {
        throw new Error('addCampaing no está implementado para web')
    }

    const db = await getDb()

    await db.transaction(async (txn) => {
        // 1. Preparar datos a guardar (convertir tipos para SQLite)
        const agendas_ids = campaing.schedules?.map((item) => item._id) || []
        const stepsJson = JSON.stringify(Array.isArray(campaing.steps) ? campaing.steps : [])
        const schedulesJson = JSON.stringify(agendas_ids)
        const valuesJson = JSON.stringify(campaing.values || [])

        // Convertir Date a string ISO
        const dateInitStr = campaing.date_init instanceof Date ? campaing.date_init.toISOString() : campaing.date_init
        const dateFinishStr = campaing.date_finish instanceof Date ? campaing.date_finish.toISOString() : campaing.date_finish
        const dateModerationInitStr =
            campaing.date_moderation_init instanceof Date ? campaing.date_moderation_init.toISOString() : campaing.date_moderation_init
        const dateModerationFinishStr =
            campaing.date_moderation_finish instanceof Date ? campaing.date_moderation_finish.toISOString() : campaing.date_moderation_finish

        // Convertir boolean a number (0 o 1)
        const scheduleFreeNum = campaing.schedule_free ? 1 : 0
        const moderationNum = campaing.moderation ? 1 : 0

        // 2. Verificar si existe (solo campos necesarios para validación)
        const existing = await txn.getFirst<{
            date_moderation_init: string | null
            date_moderation_finish: string | null
            moderation: number
            schedules: string
        }>({
            sql: `SELECT date_moderation_init, date_moderation_finish, moderation, schedules 
                  FROM ${SCHEDULES_STORE_NAMES.CAMPAINGS} 
                  WHERE _id = ?`,
            params: [campaing._id],
        })

        // 3. Datos comunes para INSERT y UPDATE
        const commonParams = [
            campaing.name,
            campaing.code,
            campaing.image,
            dateInitStr,
            dateFinishStr,
            stepsJson,
            campaing.total_progres,
            schedulesJson,
            valuesJson,
            scheduleFreeNum,
            dateModerationInitStr,
            dateModerationFinishStr,
            moderationNum,
        ]

        // 4. Si NO existe → INSERT
        if (!existing) {
            await txn.run({
                sql: `INSERT INTO ${SCHEDULES_STORE_NAMES.CAMPAINGS} (
                    _id, name, code, image, date_init, date_finish, steps, 
                    total_progres, schedules, camp_values, schedule_free,
                    date_moderation_init, date_moderation_finish, moderation
                ) VALUES (?,?,?,?,?,?,?,?,?,?,?,?,?,?);`,
                params: [campaing._id, ...commonParams],
            })

            console.log('🚀 Campaña insertada:', campaing._id)
            return { action: 'inserted', _id: campaing._id }
        }

        // 5. Si existe → validar cambios (incluyendo schedules)
        const needsUpdate =
            existing.date_moderation_init !== dateModerationInitStr ||
            existing.date_moderation_finish !== dateModerationFinishStr ||
            existing.moderation !== moderationNum ||
            existing.schedules !== schedulesJson // ✅ Nuevo: detecta cambios en agendas

        if (!needsUpdate) {
            console.log('🚀 Campaña sin cambios:', campaing._id)
            return { action: 'skipped', _id: campaing._id }
        }

        // 6. Actualizar
        await txn.run({
            sql: `UPDATE ${SCHEDULES_STORE_NAMES.CAMPAINGS} SET 
                name = ?, code = ?, image = ?, date_init = ?, date_finish = ?, 
                steps = ?, total_progres = ?, schedules = ?, camp_values = ?, 
                schedule_free = ?, date_moderation_init = ?, date_moderation_finish = ?, 
                moderation = ?
                WHERE _id = ?`,
            params: [...commonParams, campaing._id],
        })

        console.log('🚀 Campaña actualizada:', campaing._id)
        return { action: 'updated', _id: campaing._id }
    })
}

/**
 * @description Guarda formularios en lotes optimizados (con INSERT OR REPLACE para upsert)
 * @param forms Array de formularios a guardar
 * @param wise Indica si es wise (default false)
 * @param heladera Indica si tiene heladera (default false)
 * @param create_refrigerator Indica si crea refrigerador (default false)
 * @param form_id_father ID del formulario padre (default '')
 * @param batchSize Tamaño inicial del lote (default 50, reducido para evitar locks)
 * @returns Promise con cantidad de formularios guardados
 */
export async function saveFormsBatch(
    forms: any[],
    wise = false,
    heladera = false,
    create_refrigerator = false,
    form_id_father = '',
    batchSize = 500,
): Promise<number> {
    if (isWeb()) {
        throw new Error('saveFormsBatch no está implementado para web')
    }

    if (!forms || forms.length === 0) {
        return 0
    }

    const db = await getDb()
    let totalSaved = 0
    const maxRetries = 5
    let currentBatchSize = batchSize

    // Auto-ajuste para límite SQL: 999 variables / 3 columnas = 333 max
    const MAX_SAFE_BATCH = Math.floor(999 / 3)

    if (currentBatchSize > MAX_SAFE_BATCH) {
        console.log(`⚠️ Batch size ajustado de ${currentBatchSize} a ${MAX_SAFE_BATCH} para evitar límite SQL`)
        currentBatchSize = MAX_SAFE_BATCH
    }

    console.log(`🔄 Iniciando guardado de ${forms.length} formularios en batches de ${currentBatchSize}...`)

    // Dividir en chunks y procesar con auto-ajuste de tamaño
    for (let i = 0; i < forms.length; i += currentBatchSize) {
        const chunk = forms.slice(i, i + currentBatchSize)
        let retryCount = 0
        let success = false

        while (retryCount < maxRetries && !success) {
            retryCount++
            try {
                const saved = await db.transaction<number>(async (txn) => {
                    // Construir INSERT masivo con múltiples VALUES en una sola query
                    const placeholders = chunk
                        .map(
                            () =>
                                '(?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)'
                        )
                        .join(',')
                    const allParams: any[] = []

                    for (const form of chunk) {
                        allParams.push(
                            form._id,
                            form.index_form ?? null,
                            form.repeat ?? false,
                            form.can_repeat ?? false,
                            form.icon ?? '',
                            form.check_in ?? false,
                            form.name_form ?? '',
                            form.icon_check ?? '',
                            JSON.stringify(form.type_form || {}),
                            JSON.stringify(form.contents || []),
                            JSON.stringify(form.segments || []),
                            0, // status siempre 0 para nuevos formularios
                            form.progress ?? false,
                            form.totalScore ?? 0,
                            form.show_barcode ?? false,
                            JSON.stringify(form.tags || []),
                            wise ? 1 : 0,
                            heladera ? 1 : 0,
                            create_refrigerator ? 1 : 0,
                            form_id_father || '',
                            form.start_ejecution ?? '',
                            form.end_ejecution ?? '',
                            form.link ?? '',
                            form.objective ?? null,
                            form.weigh ?? null,
                            JSON.stringify(form.scores || []),
                            JSON.stringify(form.weights || []),

                        )
                    }

                    // Ejecutar una sola query con todos los valores
                    await txn.run({
                        sql: `INSERT OR REPLACE INTO ${SCHEDULES_STORE_NAMES.FORMS} (
                            _id, index_form, repeat, can_repeat, icon, check_in, 
                            name_form, icon_check, type_form, contents, segments, 
                            status, progress, totalScore, show_barcode, tags, 
                            wise, heladera, create_refrigerator, form_id_father, 
                            start_ejecution, end_ejecution, link, objective, weigh,scores, weights
                        ) VALUES ${placeholders};`,
                        params: allParams,
                    })

                    return chunk.length
                })

                totalSaved += saved
                success = true

                const progress = Math.round((totalSaved / forms.length) * 100)
                console.log(`✅ Batch ${Math.floor(i / currentBatchSize) + 1}: ${saved} forms guardados (${progress}%)`)

                if ((i / currentBatchSize) % 2 === 1) await yieldToUI()
            } catch (error: any) {
                const errorMsg = error.message || ''

                // Si falla por demasiadas variables SQL, reducir tamaño del batch
                if (errorMsg.includes('too many SQL variables') && currentBatchSize > 1) {
                    currentBatchSize = Math.floor(currentBatchSize / 2)
                    console.log(`⚠️ Reduciendo batch size a ${currentBatchSize} debido a límite SQL`)
                    // Reintentar este chunk con el nuevo tamaño
                    i -= currentBatchSize * 2 // Retroceder el índice
                    break // Salir del while para reintentar con batch más pequeño
                }

                // Si es error de lock, esperar y reintentar
                if (errorMsg.includes('database is locked') && retryCount < maxRetries) {
                    const waitTime = retryCount * 500 // 100ms, 200ms, 300ms
                    console.log(`⚠️ DB bloqueada, esperando ${waitTime}ms antes de reintentar (intento ${retryCount}/${maxRetries})`)
                    await new Promise((resolve) => setTimeout(resolve, waitTime))
                    continue
                }

                // Error no recuperable
                console.error(`❌ Error guardando forms batch:`, error)

                if (retryCount >= maxRetries) {
                    console.error(`❌ Máximo de reintentos alcanzado para batch`)
                }

                // Cualquier otro error, propagar
                throw error
            }
        }

        // Si no tuvo éxito después de todos los reintentos, lanzar error
        if (!success) {
            throw new Error(`No se pudo guardar el batch después de ${maxRetries} intentos`)
        }
    }

    console.log(`🎉 Total formularios guardados: ${totalSaved}/${forms.length}`)
    return totalSaved
}

/**
 * @description Obtiene todas las campañas con sus agendas (schedules) asociadas
 * @returns Promise con array de campañas completas
 *
 * OPTIMIZACIÓN: En lugar de hacer N queries dentro de un loop (N+1 problem),
 * ahora hace 2 queries totales:
 * 1. SELECT de todas las campañas
 * 2. SELECT de todos los schedules en una sola query con WHERE IN
 *
 * Performance: 10-100x más rápido dependiendo de cantidad de campañas y schedules
 */
export async function getAllCampaigns(): Promise<any[]> {
    if (isWeb()) {
        throw new Error('getAllCampaigns no está implementado para web')
    }

    const db = await getDb()

    // 1. Obtener todas las campañas
    const campaignRows = await db.getAll<any>({
        sql: `SELECT * FROM ${SCHEDULES_STORE_NAMES.CAMPAINGS}`,
        params: [],
    })

    if (!campaignRows || campaignRows.length === 0) {
        return []
    }

    // 2. Construir objeto de campañas y recolectar todos los schedule IDs
    const campaigns: any[] = []
    const allScheduleIds: string[] = []
    const scheduleIdToCampaignIndex = new Map<string, number[]>() // Map schedule_id -> campaign indexes

    campaignRows.forEach((row, index) => {
        const scheduleIds = JSON.parse(row.schedules || '[]')

        campaigns.push({
            _id: row._id,
            name: row.name,
            code: row.code,
            image: row.image,
            date_int: row.date_init,
            date_finish: row.date_finish,
            steps: JSON.parse(row.steps || '[]'),
            total_progres: row.total_progres,
            scheduleIds: scheduleIds,
            values: JSON.parse(row.camp_values || '[]'),
            schedules: [], // Se llenará después
            schedule_free: row.schedule_free,
            date_moderation_init: row.date_moderation_init,
            date_moderation_finish: row.date_moderation_finish,
            moderation: row.moderation,
        })

        // Mapear qué schedules pertenecen a qué campaña
        scheduleIds.forEach((scheduleId: string) => {
            if (!allScheduleIds.includes(scheduleId)) {
                allScheduleIds.push(scheduleId)
            }

            const existingIndexes = scheduleIdToCampaignIndex.get(scheduleId) || []
            existingIndexes.push(index)
            scheduleIdToCampaignIndex.set(scheduleId, existingIndexes)
        })
    })

    // 3. Si no hay schedules, devolver las campañas vacías
    if (allScheduleIds.length === 0) {
        return campaigns
    }

    // 4. ✨ OPTIMIZACIÓN: Una sola query para obtener TODOS los schedules
    // En lugar de N queries (una por schedule), hacemos 1 query con WHERE IN
    const placeholders = allScheduleIds.map(() => '?').join(',')
    const scheduleRows = await db.getAll<any>({
        sql: `SELECT * FROM ${SCHEDULES_STORE_NAMES.SCHEDULES} WHERE _id IN (${placeholders})`,
        params: allScheduleIds,
    })

    // 5. Construir un mapa de schedules para acceso O(1)
    const scheduleMap = new Map<string, any>()
    scheduleRows.forEach((scheduleRow) => {
        const schedule = {
            _id: scheduleRow._id,
            date_finish: scheduleRow.date_finish,
            date_init: scheduleRow.date_init,
            form_finish: scheduleRow.form_finish?.length > 6 ? JSON.parse(scheduleRow.form_finish) : null,
            form_init: scheduleRow.form_init?.length > 6 ? JSON.parse(scheduleRow.form_init) : null,
            stores: [],
            progress_diary: scheduleRow.progress_diary,
            additional: JSON.parse(scheduleRow.additional || '{}'),
            distributor: JSON.parse(scheduleRow.distributor || '{}'),
            activities: JSON.parse(scheduleRow.activities || '[]'),
            others_activities: JSON.parse(scheduleRow.others_activities || '[]'),
            vacation: scheduleRow.vacation,
            activities_advances: JSON.parse(scheduleRow.activities_advances || '[]'),
            others_activities_advances: JSON.parse(scheduleRow.others_activities_advances || '[]'),
            forms_additionals: JSON.parse(scheduleRow.forms_additionals || '[]'),
            forms_incidence: scheduleRow.forms_incidence,
            reports: JSON.parse(scheduleRow.reports || '{}'),
            data_version: scheduleRow.data_version,
        }
        scheduleMap.set(scheduleRow._id, schedule)
    })

    // 6. Asignar schedules a sus campañas correspondientes
    campaigns.forEach((campaign) => {
        campaign.schedules = campaign.scheduleIds
            .map((scheduleId: string) => scheduleMap.get(scheduleId))
            .filter((schedule: any) => schedule !== undefined) // Filtrar schedules no encontrados
    })

    return campaigns
}

/**
 * @description Guarda schedules (agendas) en lotes optimizados
 * @param schedules Array de schedules a guardar
 * @param campaign_id ID de la campaña a la que pertenecen los schedules
 * @param batchSize Tamaño inicial del lote (default 100, optimizado para evitar locks)
 * @returns Promise con cantidad de schedules guardados
 *
 * OPTIMIZACIÓN: Usa INSERT masivo con placeholders en lugar de N inserts individuales
 * Performance: 10-50x más rápido con batch inserts vs inserts individuales
 */
export async function addSchedulesBatch(schedules: any[], campaign_id: string, batchSize = 100): Promise<number> {
    console.log(`Iniciando addSchedulesBatch con ${schedules.length} schedules para campaña ${campaign_id}`)
    console.log(`Iniciando addSchedulesBatch con ${schedules}`)

    if (isWeb()) {
        throw new Error('addSchedulesBatch no está implementado para web')
    }

    if (!schedules || schedules.length === 0) {
        return 0
    }

    const db = await getDb()
    let currentBatchSize = batchSize
    let totalSaved = 0

    // Dividir en chunks y procesar con auto-ajuste de tamaño
    for (let i = 0; i < schedules.length; i += currentBatchSize) {
        const chunk = schedules.slice(i, i + currentBatchSize)
        let success = false
        let retryCount = 0
        const maxRetries = 5

        while (!success && retryCount < maxRetries) {
            try {
                await db.transaction(async (txn) => {
                    // Construir INSERT masivo con múltiples VALUES en una sola query
                    // 19 columnas por schedule
                    const placeholders = chunk.map(() => '(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)').join(',')

                    const allParams: any[] = []
                    for (const schedule of chunk) {
                        allParams.push(
                            schedule._id,
                            schedule.date_finish || '',
                            schedule.date_init || '',
                            JSON.stringify(schedule.form_finish || {}),
                            JSON.stringify(schedule.form_init || {}),
                            '[]', // stores vacíos inicialmente
                            campaign_id,
                            schedule.progress_diary ?? false,
                            JSON.stringify(schedule.additional || {}),
                            JSON.stringify(schedule.activities || []),
                            JSON.stringify(schedule.others_activities || []),
                            JSON.stringify(schedule.distributor || {}),
                            schedule.vacation ?? false,
                            JSON.stringify(schedule.activities_advances || {}),
                            JSON.stringify(schedule.others_activities_advances || {}),
                            JSON.stringify(schedule.forms_additionals || []),
                            schedule.forms_incidence ?? false,
                            JSON.stringify(schedule.reports || {}),
                            schedule.data_version ?? 0,
                        )
                    }

                    // Ejecutar una sola query con todos los valores
                    await txn.run({
                        sql: `INSERT OR REPLACE INTO ${SCHEDULES_STORE_NAMES.SCHEDULES} (
                            _id,
                            date_finish,
                            date_init,
                            form_finish,
                            form_init,
                            stores,
                            campaign_id,
                            progress_diary,
                            additional,
                            activities,
                            others_activities,
                            distributor,
                            vacation,
                            activities_advances,
                            others_activities_advances,
                            forms_additionals,
                            forms_incidence,
                            reports,
                            data_version
                        ) VALUES ${placeholders};`,
                        params: allParams,
                    })

                    return { saved: chunk.length }
                })

                totalSaved += chunk.length
                success = true
                console.log(
                    `✅ Guardados ${chunk.length} schedules (batch ${Math.floor(i / currentBatchSize) + 1}/${Math.ceil(schedules.length / currentBatchSize)})`,
                )
            } catch (error: any) {
                const errorMsg = error.message || ''

                // Si es error de lock, esperar y reintentar
                if (errorMsg.includes('database is locked')) {
                    retryCount++
                    if (retryCount < maxRetries) {
                        const waitTime = retryCount * 500 // 100ms, 200ms, 300ms
                        console.log(`⚠️ DB bloqueada, esperando ${waitTime}ms antes de reintentar (intento ${retryCount}/${maxRetries})`)
                        await new Promise((resolve) => setTimeout(resolve, waitTime))
                        continue
                    } else {
                        console.error(`❌ DB bloqueada después de ${maxRetries} intentos`)
                        throw error
                    }
                }

                // Si falla por demasiadas variables SQL, reducir tamaño del batch
                if (errorMsg.includes('too many SQL variables') && currentBatchSize > 1) {
                    currentBatchSize = Math.floor(currentBatchSize / 2)
                    console.log(`⚠️ Reduciendo batch size a ${currentBatchSize} debido a límite SQL`)
                    retryCount = 0 // Reset retry count cuando cambiamos batch size
                    break // Salir del while para reintentar con batch más pequeño
                }

                // Cualquier otro error, propagar
                throw error
            }
        }

        // Si no tuvo éxito después de todos los reintentos, lanzar error
        if (!success) {
            throw new Error(`No se pudo guardar el batch después de ${maxRetries} intentos`)
        }
    }

    console.log(`🎉 Total schedules guardados: ${totalSaved}/${schedules.length}`)
    return totalSaved
}

/**
 * @description Guarda stores (tiendas) en lotes optimizados con sus KPIs
 * @param stores Array de stores a guardar
 * @param batchSize Tamaño inicial del lote (default 500, optimizado para evitar locks)
 * @param step Paso del progress bar (opcional)
 * @param setProgress Callback para actualizar progreso (opcional)
 * @returns Promise con cantidad de stores guardados
 *
 * OPTIMIZACIÓN:
 * 1. INSERT masivo para stores
 * 2. INSERT masivo separado para KPIs (si existen)
 * 3. Evita llamadas individuales a updateStoreKPIS
 * Performance: 20-100x más rápido con batch inserts
 */
export async function addStoresBatch(stores: any[], batchSize = 500, step?: string, setProgress?: (progress: number) => void): Promise<number> {
    if (isWeb()) {
        throw new Error('addStoresBatch no está implementado para web')
    }

    if (!stores || stores.length === 0) {
        return 0
    }

    const storesBeforeFilter = stores.length
    const validStores = stores.filter(store => {
        if (!store._id) {
            console.warn('⚠️ [addStoresBatch] Store descartado: sin _id', { segment: store.segment, name: store.name })
            return false
        }
        
        return true
    })
    
    if (validStores.length < storesBeforeFilter) {
        const discarded = storesBeforeFilter - validStores.length
        console.warn(`🚨 [addStoresBatch] Se descartaron ${discarded} stores inválidos de ${storesBeforeFilter}`)
        console.warn(`✅ [addStoresBatch] Stores válidos a guardar: ${validStores.length}`)
    }
    
    // Si después del filtrado no hay stores válidos, retornar
    if (validStores.length === 0) {
        console.warn('⚠️ [addStoresBatch] No hay stores válidos para guardar')
        return 0
    }
    
    // Usar validStores en lugar de stores
    stores = validStores

    const db = await getDb()
    let totalSaved = 0
    const maxRetries = 5
    let currentBatchSize = batchSize
    const totalStores = stores.length

    // Auto-ajuste para límite SQL: 999 variables / 3 columnas = 333 max
    const MAX_SAFE_BATCH = Math.floor(999 / 3)

    if (currentBatchSize > MAX_SAFE_BATCH) {
        console.log(`⚠️ Batch size ajustado de ${currentBatchSize} a ${MAX_SAFE_BATCH} para evitar límite SQL`)
        currentBatchSize = MAX_SAFE_BATCH
    }

    console.log(`🔄 Iniciando guardado de ${stores.length} stores en batches de ${currentBatchSize}...`)

    // Dividir en chunks y procesar con auto-ajuste de tamaño
    for (let i = 0; i < stores.length; i += currentBatchSize) {
        const chunk = stores.slice(i, i + currentBatchSize)
        let retryCount = 0
        let success = false
        // const maxRetries = 5 // Aumentado de 3 a 5

        while (retryCount < maxRetries && !success) {
            retryCount++
            try {
                const saved = await db.transaction<number>(async (txn) => {
                    // 1. INSERT masivo de stores (18 columnas)
                    const placeholders = chunk.map(() => '(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)').join(',')
                    const allStoreParams: any[] = []

                    const storesWithKPIs: Array<{ store_id: string; kpis: any[] }> = []

                    for (const store of chunk) {
                        // Recolectar stores con KPIs para procesarlos después
                        if (store.kpis_indicators && store.kpis_indicators.length > 0) {
                            // ✅ Validar que todos los KPIs tengan index
                            const validatedKPIs = store.kpis_indicators.map((kpi, idx) => {
                                if (kpi.index === undefined || kpi.index === null) {
                                    console.warn(`⚠️ KPI del servidor sin index: ${kpi.kpi} (store: ${store.code}), se asignará ${idx}`)
                                    return { ...kpi, index: idx }
                                }
                                return kpi
                            })
                            
                            storesWithKPIs.push({
                                store_id: store._id,
                                kpis: validatedKPIs,
                            })
                        }

                        allStoreParams.push(
                            store._id,
                            store.name || '',
                            store.address || '',
                            parseFloat(store.lat) || 0,
                            parseFloat(store.lng) || 0,
                            store.code || '',
                            store.cluster || '',
                            store.area || '',
                            store.region || '',
                            store.format || '',
                            store.flag || '',
                            store.maximum_distance_for_checkin || 0,
                            store.segment || '',
                            true, // existsInDB
                            store._id, // _id_mongoDB
                            store.frequency || '',
                            store.topstore || '',
                            store.potencial || '',
                        )
                    }

                    // Ejecutar INSERT masivo de stores
                    await txn.run({
                        sql: `INSERT OR REPLACE INTO ${SCHEDULES_STORE_NAMES.STORES} (
                            _id,
                            name,
                            address,
                            lat,
                            lng,
                            code,
                            cluster,
                            area,
                            region,
                            format,
                            flag,
                            maximum_distance_for_checkin,
                            segment,
                            existsInDB,
                            _id_mongoDB,
                            frequency,
                            topstore,
                            potencial
                        ) VALUES ${placeholders};`,
                        params: allStoreParams,
                    })

                    // 2. ✨ OPTIMIZACIÓN: INSERT masivo de KPIs (si hay)
                    if (storesWithKPIs.length > 0) {
                        const kpiPlaceholders = storesWithKPIs.map(() => '(?,?)').join(',')
                        const kpiParams: any[] = []

                        for (const { store_id, kpis } of storesWithKPIs) {
                            kpiParams.push(store_id, JSON.stringify(kpis))
                        }

                        await txn.run({
                            sql: `INSERT OR REPLACE INTO ${SCHEDULES_STORE_NAMES.STORES_INDICATORS} (
                                store_id, indicators
                            ) VALUES ${kpiPlaceholders};`,
                            params: kpiParams,
                        })

                        console.log(`📊 Guardados ${storesWithKPIs.length} KPIs en batch`)
                    }

                    return chunk.length
                })

                totalSaved += saved
                success = true

                if (step && setProgress) {
                    const currentIndex = Math.min(i + currentBatchSize, stores.length)
                    const progressSteps = {
                        // STEP_4: { start: 0, end: 100 }
                        STEP_4: { start: 42, end: 57 },
                    } as any

                    if (progressSteps[step]) {
                        const { start, end } = progressSteps[step]
                        const progress = Math.round(start + (end - start) * (currentIndex / stores.length))
                        setProgress(progress)
                    }
                }

                const progress = Math.round((totalSaved / stores.length) * 100)
                console.log(`✅ Batch ${Math.floor(i / currentBatchSize) + 1}: ${saved} stores guardados (${progress}%)`)

                if ((i / currentBatchSize) % 2 === 1) await yieldToUI()
            } catch (error: any) {
                const errorMsg = error.message || ''

                // Si es error de lock, esperar y reintentar
                if (errorMsg.includes('database is locked')) {
                    retryCount++
                    if (retryCount < maxRetries) {
                        const waitTime = retryCount * 500
                        console.log(`⚠️ DB bloqueada, esperando ${waitTime}ms antes de reintentar (intento ${retryCount}/${maxRetries})`)
                        await new Promise((resolve) => setTimeout(resolve, waitTime))
                        continue
                    } else {
                        console.error(`❌ DB bloqueada después de ${maxRetries} intentos`)
                        throw error
                    }
                }

                // Si falla por demasiadas variables SQL, reducir tamaño del batch
                if (errorMsg.includes('too many SQL variables') && currentBatchSize > 1) {
                    currentBatchSize = Math.floor(currentBatchSize / 2)
                    console.log(`⚠️ Reduciendo batch size a ${currentBatchSize} debido a límite SQL`)
                    retryCount = 0
                    break
                }

                throw error
            }
        }

        if (!success) {
            throw new Error(`No se pudo guardar el batch después de ${maxRetries} intentos`)
        }
    }

    console.log(`🎉 Total stores guardados: ${totalSaved}/${stores.length}`)
    return totalSaved
}

/**
 * Guarda múltiples relaciones schedule-store (POS) en batch optimizado
 * @param posSchedules - Array de relaciones store-schedule a guardar
 * @param batchSize - Tamaño del batch (default: 100)
 * @param step - Step del progreso (opcional)
 * @param setProgress - Callback para actualizar progreso (opcional)
 * @returns Número total de registros guardados
 */
export async function addPosSchedulesBatch(
    posSchedules: any[],
    batchSize = 500,
    step?: string,
    setProgress?: (progress: number) => void,
): Promise<number> {
    if (!posSchedules || posSchedules.length === 0) {
        console.log('⚠️ No hay posSchedules para guardar')
        return 0
    }

    const db = await getDb()
    let totalSaved = 0
    const maxRetries = 5
    let currentBatchSize = batchSize

    // Calcular límite de variables SQL (999 / 10 columnas = ~99 registros seguros)
    // const MAX_VARIABLES = 999
    // const COLUMNS_PER_SCHEDULE = 10

    // Auto-ajuste para límite SQL: 999 variables / 3 columnas = 333 max
    const MAX_SAFE_BATCH = Math.floor(999 / 3)

    if (currentBatchSize > MAX_SAFE_BATCH) {
        console.log(`⚠️ Batch size ajustado de ${currentBatchSize} a ${MAX_SAFE_BATCH} para evitar límite SQL`)
        // console.log(`⚠️ Batch size ${currentBatchSize} excede límite SQL, ajustando a ${MAX_SAFE_BATCH}`)
        currentBatchSize = MAX_SAFE_BATCH
    }

    console.log(`🔄 Iniciando guardado de ${posSchedules.length} pos schedules en batches de ${currentBatchSize}...`)

    for (let i = 0; i < posSchedules.length; i += currentBatchSize) {
        const chunk = posSchedules.slice(i, i + currentBatchSize)
        let retryCount = 0
        let success = false
        // const maxRetriesLocal = 5 // Aumentado a 5 intentos

        while (retryCount < maxRetries && !success) {
            retryCount++
            try {
                const saved = await db.transaction<number>(async (txn) => {
                    // Construir placeholders para batch INSERT
                    const placeholders = chunk.map(() => '(?,?,?,?,?,?,?,?,?,?)').join(',')
                    const allParams: any[] = []

                    for (const schedule of chunk) {
                        allParams.push(
                            schedule._id,
                            schedule.store_id,
                            schedule.schedule_id,
                            JSON.stringify(schedule.forms || []),
                            JSON.stringify(schedule.forms_relevant || []),
                            JSON.stringify(schedule.forms_featured || []),
                            schedule.campaign_status,
                            parseFloat(schedule.lat) || 0,
                            parseFloat(schedule.lng) || 0,
                            1, // existsInDB = true
                        )
                    }

                    // Single INSERT OR REPLACE con todos los registros
                    await txn.run({
                        sql: `INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULES_POS} (
                            _id,
                            store_id,
                            schedule_id,
                            forms,
                            forms_relevant,
                            forms_featured,
                            campaign_status,
                            lat,
                            lng,
                            existsInDB
                        ) VALUES ${placeholders}`,
                        params: allParams,
                    })

                    return chunk.length
                })

                totalSaved += saved
                success = true

                // Actualizar progreso si se proporcionó callback
                if (step && setProgress) {
                    const currentIndex = Math.min(i + currentBatchSize, posSchedules.length)
                    const progressSteps = {
                        // STEP_7: { start: 0, end: 100 }
                        STEP_7: { start: 85, end: 99 },
                    } as any

                    if (progressSteps[step]) {
                        const { start, end } = progressSteps[step]
                        const progress = Math.round(start + (end - start) * (currentIndex / posSchedules.length))
                        setProgress(progress)
                    }
                }

                const progress = Math.round((totalSaved / posSchedules.length) * 100)
                console.log(`✅ Batch ${Math.floor(i / currentBatchSize) + 1}: ${saved} pos schedules guardados (${progress}%)`)

                if ((i / currentBatchSize) % 2 === 1) await yieldToUI()
            } catch (error: any) {
                // retryCount++

                // Verificar si es error de variables SQL
                if (error.message?.includes('too many SQL variables') && currentBatchSize > 1) {
                    // Reducir batch size a la mitad
                    currentBatchSize = Math.floor(currentBatchSize / 2)
                    console.log(`⚠️ Demasiadas variables SQL, reduciendo batch a ${currentBatchSize}`)
                    // Reintentar este chunk con el nuevo tamaño
                    i -= currentBatchSize * 2 // Retroceder el índice
                    break
                }

                // Verificar si es error de database lock
                if (error.message?.includes('database is locked') && retryCount < maxRetries) {
                    const waitTime = retryCount * 500
                    console.log(`⏳ Database locked, reintentando en ${waitTime}ms (intento ${retryCount}/${maxRetries})...`)
                    await new Promise((resolve) => setTimeout(resolve, waitTime))
                    continue
                }

                // Error no recuperable
                console.error(`❌ Error guardando pos schedules batch:`, error)

                if (retryCount >= maxRetries) {
                    console.error(`❌ Máximo de reintentos alcanzado para batch`)
                }

                throw error
            }
        }

        if (!success) {
            throw new Error(`No se pudo guardar el batch después de ${maxRetries} intentos`)
        }
    }

    console.log(`🎉 Total pos schedules guardados: ${totalSaved}/${posSchedules.length}`)
    return totalSaved
}

/**
 * Inserta o actualiza un advance schedule con merge inteligente de forms
 * @param schedule - Objeto con datos del advance schedule
 * @returns Promise con resultado de la operación
 */
export async function addOrUpdateAdvanceSchedule(schedule: any): Promise<{ action: 'insert' | 'update'; rowsAffected: number }> {
    if (!schedule) {
        throw new Error('Schedule data is required')
    }

    const maxRetries = 5
    let lastError: Error | null = null

    for (let retryCount = 0; retryCount < maxRetries; retryCount++) {
        try {
            const db = await getDb()

            return await db.transaction<{ action: 'insert' | 'update'; rowsAffected: number }>(async (txn) => {
                // 🔥 PRIMERO: Buscar por _id (más importante que cualquier otro criterio)
                let existingById = await txn.getFirst<{ forms: string; _id: string }>({
                    sql: `SELECT _id, forms FROM schedules_advances WHERE _id = ?`,
                    params: [schedule._id],
                })

                // Si existe por _id, hacer UPDATE directo (no importa otros campos)
                if (existingById) {
                    const formsLocal = existingById.forms ? JSON.parse(existingById.forms) : []
                    const formsLlega = schedule.forms || []
                    let finalForms = formsLlega

                    if (formsLocal && formsLocal.length > 0) {
                        // Merge: actualizar forms existentes con los nuevos datos
                        finalForms = formsLocal.map((formLocal: any) => {
                            const formLlega = formsLlega.find((f: any) => f._id === formLocal._id)
                            return formLlega || formLocal
                        })

                        // Agregar forms nuevos que no existían localmente
                        const newForms = formsLlega.filter((f: any) => !formsLocal.some((local: any) => local._id === f._id))
                        finalForms.push(...newForms)
                    }

                    // UPDATE por _id
                    const result = await txn.run({
                        sql: `UPDATE schedules_advances
                              SET pos_id = ?,
                                  schedule_id = ?,
                                  forms = ?, 
                                  status = ?, 
                                  form_id = ?, 
                                  progress = ?,
                                  score = ?, 
                                  checkin_id = ?, 
                                  date_modified = ?, 
                                  objectives = ?,
                                  distributor_id = ?,
                                  date_init = ?
                              WHERE _id = ?`,
                        params: [
                            schedule.pos_id || null,
                            schedule.schedule_id,
                            JSON.stringify(finalForms),
                            schedule.status,
                            schedule.form_id || '',
                            schedule.progress,
                            schedule.score,
                            schedule.checkin_id,
                            schedule.date_modified,
                            JSON.stringify(schedule.objectives || []),
                            schedule.distributor_id || '',
                            schedule.date_init,
                            schedule._id,
                        ],
                    })

                    console.log(`✅ Schedule advance actualizado por _id: ${schedule._id}`)
                    return { action: 'update', rowsAffected: result.changes || 0 }
                }

                // 🔍 SEGUNDO: Si no existe por _id, buscar por otros criterios para merge
                let whereClause = ''
                let selectParams: any[] = []

                // Determinar el whereClause según el tipo de schedule
                if (schedule.form_id && schedule.form_id !== '') {
                    // Caso 1: form_id (formularios de agenda matutino/vespertino)
                    whereClause = `form_id = ? AND schedule_id = ? AND date(date_init) = date('now')`
                    selectParams = [schedule.form_id, schedule.schedule_id]
                } else if (schedule.distributor_id && schedule.distributor_id !== '') {
                    // Caso 2: distributor_id
                    whereClause = `distributor_id = ? AND schedule_id = ? AND date(date_init) = date('now')`
                    selectParams = [schedule.distributor_id, schedule.schedule_id]
                } else {
                    // Caso 3: pos_id (más común)
                    if (schedule.recover_forms) {
                        whereClause = `pos_id = ? AND schedule_id = ? AND (checkin_id = ? OR checkin_id IS NULL)`
                        selectParams = [schedule.pos_id, schedule.schedule_id, schedule.checkin_id]
                    } else {
                        whereClause = `pos_id = ? AND schedule_id = ? AND date(date_init) = date('now') AND (checkin_id = ? OR checkin_id IS NULL)`
                        selectParams = [schedule.pos_id, schedule.schedule_id, schedule.checkin_id]
                    }
                }

                // Buscar registro existente por otros criterios
                const existing = await txn.getFirst<{ _id: string; forms: string }>({
                    sql: `SELECT _id, forms FROM schedules_advances WHERE ${whereClause} ORDER BY date_modified DESC LIMIT 1`,
                    params: selectParams,
                })

                let finalForms = schedule.forms || []

                // Si existe por otros criterios, hacer merge y UPDATE por su _id original
                if (existing) {
                    const formsLocal = existing.forms ? JSON.parse(existing.forms) : []
                    const formsLlega = schedule.forms || []

                    if (formsLocal && formsLocal.length > 0) {
                        // Merge: actualizar forms existentes con los nuevos datos
                        finalForms = formsLocal.map((formLocal: any) => {
                            const formLlega = formsLlega.find((f: any) => f._id === formLocal._id)
                            return formLlega || formLocal
                        })

                        // Agregar forms nuevos que no existían localmente
                        const newForms = formsLlega.filter((f: any) => !formsLocal.some((local: any) => local._id === f._id))
                        finalForms.push(...newForms)
                    } else {
                        finalForms = formsLlega
                    }

                    // ⚠️ IMPORTANTE: UPDATE por el _id del registro existente (no por whereClause)
                    // Esto evita UNIQUE constraint errors
                    const result = await txn.run({
                        sql: `UPDATE schedules_advances
                              SET pos_id = ?,
                                  schedule_id = ?,
                                  forms = ?, 
                                  status = ?, 
                                  form_id = ?, 
                                  progress = ?,
                                  score = ?, 
                                  checkin_id = ?, 
                                  date_modified = ?, 
                                  objectives = ?,
                                  distributor_id = ?,
                                  date_init = ?
                              WHERE _id = ?`,
                        params: [
                            schedule.pos_id || null,
                            schedule.schedule_id,
                            JSON.stringify(finalForms),
                            schedule.status,
                            schedule.form_id || '',
                            schedule.progress,
                            schedule.score,
                            schedule.checkin_id,
                            schedule.date_modified,
                            JSON.stringify(schedule.objectives || []),
                            schedule.distributor_id || '',
                            schedule.date_init,
                            existing._id, // ✅ Usar el _id del registro existente, no el nuevo
                        ],
                    })

                    console.log(`✅ Schedule advance actualizado por criterios (mantiene _id original: ${existing._id})`)
                    return { action: 'update', rowsAffected: result.changes || 0 }
                } else {
                    // ✨ No existe en DB → INSERT nuevo registro
                    const result = await txn.run({
                        sql: `INSERT INTO schedules_advances (
                                _id, 
                                pos_id, 
                                schedule_id, 
                                forms, 
                                status, 
                                date_init, 
                                form_id, 
                                progress, 
                                score, 
                                checkin_id, 
                                date_modified, 
                                distributor_id, 
                                objectives
                              ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`,
                        params: [
                            schedule._id,
                            schedule.pos_id || null,
                            schedule.schedule_id,
                            JSON.stringify(finalForms),
                            schedule.status,
                            schedule.date_init,
                            schedule.form_id || '',
                            schedule.progress,
                            schedule.score,
                            schedule.checkin_id,
                            schedule.date_modified,
                            schedule.distributor_id || '',
                            JSON.stringify(schedule.objectives || []),
                        ],
                    })

                    console.log(`✅ Schedule advance insertado con _id: ${schedule._id}`)
                    return { action: 'insert', rowsAffected: result.changes || 0 }
                }
            })
        } catch (error: any) {
            lastError = error

            // Verificar si es error de database lock
            if (error.message?.includes('database is locked') && retryCount < maxRetries - 1) {
                const waitTime = (retryCount + 1) * 200 // 200ms, 400ms, 600ms, 800ms, 1000ms
                console.log(
                    `⏳ [addOrUpdateAdvanceSchedule] Database locked, reintentando en ${waitTime}ms (intento ${retryCount + 1}/${maxRetries})...`,
                )
                await new Promise((resolve) => setTimeout(resolve, waitTime))
                continue
            }

            // Si no es database lock o ya superamos los reintentos, lanzar error
            if (retryCount >= maxRetries - 1) {
                console.error(`❌ [addOrUpdateAdvanceSchedule] Máximo de reintentos alcanzado para schedule ${schedule._id}`)
            }
            throw error
        }
    }

    // Si llegamos aquí, significa que se superaron todos los reintentos
    throw lastError || new Error('Failed to save advance schedule after retries')
}

/**
 * Guarda múltiples links de assets en batch optimizado
 * Antes: forEach con N queries individuales
 * Después: Single INSERT con múltiples VALUES (100-1000x más rápido)
 * @param dataLinks - Array de URLs de assets
 * @param batchSize - Tamaño del batch (default: 500)
 * @returns Número total de links guardados
 */
export async function saveAllLinksAssetsBatch(dataLinks: string[], batchSize = 500): Promise<number> {
    if (!dataLinks || dataLinks.length === 0) {
        console.log('⚠️ No hay links de assets para guardar')
        return 0
    }

    const db = await getDb()
    let totalSaved = 0
    const statusNoDownload = 0
    const maxRetries = 5
    let currentBatchSize = batchSize

    // Calcular límite de variables SQL (999 / 3 columnas = ~333 registros seguros)
    const MAX_VARIABLES = 999
    const COLUMNS_PER_LINK = 3
    const MAX_SAFE_BATCH = Math.floor(MAX_VARIABLES / COLUMNS_PER_LINK)

    if (currentBatchSize > MAX_SAFE_BATCH) {
        console.log(`⚠️ Batch size ${currentBatchSize} excede límite SQL, ajustando a ${MAX_SAFE_BATCH}`)
        currentBatchSize = MAX_SAFE_BATCH
    }

    console.log(`📦 Guardando ${dataLinks.length} links de assets en batches de ${currentBatchSize}...`)

    for (let i = 0; i < dataLinks.length; i += currentBatchSize) {
        const chunk = dataLinks.slice(i, i + currentBatchSize)
        let retryCount = 0
        let success = false
        const maxRetriesLocal = 5 // Aumentado a 5 intentos

        while (retryCount < maxRetriesLocal && !success) {
            try {
                const saved = await db.transaction<number>(async (txn) => {
                    // Construir placeholders para batch INSERT
                    const placeholders = chunk.map(() => '(?,?,?)').join(',')

                    // Preparar todos los parámetros en un solo array
                    const allParams: any[] = []

                    chunk.forEach((link, chunkIndex) => {
                        const globalIndex = i + chunkIndex
                        allParams.push(
                            globalIndex, // indexRoute
                            statusNoDownload, // status (0 = no descargado)
                            link, // rute (URL)
                        )
                    })

                    // Single INSERT con todos los registros
                    await txn.run({
                        sql: `INSERT INTO assets_pf_links (
                            indexRoute,
                            status,
                            rute
                        ) VALUES ${placeholders}`,
                        params: allParams,
                    })

                    return chunk.length
                })

                totalSaved += saved
                success = true

                const progress = Math.round((totalSaved / dataLinks.length) * 100)
                console.log(`✅ Batch ${Math.floor(i / currentBatchSize) + 1}: ${saved} links guardados (${progress}%)`)
            } catch (error: any) {
                retryCount++

                // Verificar si es error de variables SQL
                if (error.message?.includes('too many SQL variables') && currentBatchSize > 1) {
                    const newBatchSize = Math.floor(currentBatchSize / 2)
                    console.log(`⚠️ Demasiadas variables SQL, reduciendo batch de ${currentBatchSize} a ${newBatchSize}`)
                    currentBatchSize = newBatchSize

                    // Reintentar este chunk con el nuevo tamaño
                    i -= currentBatchSize
                    break
                }

                // Verificar si es error de database lock
                if (error.message?.includes('database is locked') && retryCount < maxRetries) {
                    const waitTime = retryCount * 500
                    console.log(`⏳ Database locked, reintentando en ${waitTime}ms (intento ${retryCount}/${maxRetries})...`)
                    await new Promise((resolve) => setTimeout(resolve, waitTime))
                    continue
                }

                // Error no recuperable
                console.error(`❌ Error guardando links de assets batch:`, error)

                if (retryCount >= maxRetries) {
                    console.error(`❌ Máximo de reintentos alcanzado para batch`)
                }

                throw error
            }
        }

        if (!success) {
            throw new Error(`No se pudo guardar el batch después de ${maxRetries} intentos`)
        }
    }

    console.log(`🎉 Total links de assets guardados: ${totalSaved}/${dataLinks.length}`)
    return totalSaved
}

/**
 * Guarda múltiples formularios de Perfect Store en batch optimizado
 * @param data - Array de formularios Perfect Store
 * @param batchSize - Tamaño del batch (default: 500)
 * @returns Número total de formularios guardados
 */
export async function addAllFormsPFBatch(data: any[], batchSize = 500): Promise<number> {
    if (!data || data.length === 0) {
        console.log('⚠️ No hay formularios Perfect Store para guardar')
        return 0
    }

    const db = await getDb()
    let totalSaved = 0
    const maxRetries = 5
    let currentBatchSize = batchSize

    // Calcular límite de variables SQL (999 / 10 columnas = ~99 registros seguros)
    // const MAX_VARIABLES = 999
    // const COLUMNS_PER_FORM = 10

    // Auto-ajuste para límite SQL: 999 variables / 3 columnas = 333 max
    const MAX_SAFE_BATCH = Math.floor(999 / 3)

    if (currentBatchSize > MAX_SAFE_BATCH) {
        // console.log(`⚠️ Batch size ${currentBatchSize} excede límite SQL, ajustando a ${MAX_SAFE_BATCH}`)
        console.log(`⚠️ Batch size ajustado de ${currentBatchSize} a ${MAX_SAFE_BATCH} para evitar límite SQL`)
        currentBatchSize = MAX_SAFE_BATCH
    }

    console.log(`🔄 Iniciando guardado de ${data.length} formularios Perfect Store en batches de ${currentBatchSize}...`)

    for (let i = 0; i < data.length; i += currentBatchSize) {
        const chunk = data.slice(i, i + currentBatchSize)
        let retryCount = 0
        let success = false

        while (retryCount < maxRetries && !success) {
            retryCount++
            try {
                const saved = await db.transaction<number>(async (txn) => {
                    // Construir placeholders para batch INSERT
                    const placeholders = chunk.map(() => '(?,?,?,?,?,?,?,?,?,?)').join(',')
                    const allParams: any[] = []

                    for (const item of chunk) {
                        allParams.push(
                            item._id,
                            item.status,
                            item.index,
                            item.title,
                            item.icon,
                            JSON.stringify(item.medias || []),
                            JSON.stringify(item.type || {}),
                            item.start_ejecution,
                            item.end_ejecution,
                            item.tags,
                        )
                    }

                    // Single INSERT OR REPLACE con todos los registros
                    await txn.run({
                        sql: `INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_FORMS_PERFECT_STORE} (
                            _id,
                            status,
                            form_index,
                            title,
                            icon,
                            medias,
                            type,
                            start_ejecution,
                            end_ejecution,
                            tags
                        ) VALUES ${placeholders}`,
                        params: allParams,
                    })

                    return chunk.length
                })

                totalSaved += saved
                success = true

                const progress = Math.round((totalSaved / data.length) * 100)
                console.log(`✅ Batch ${Math.floor(i / currentBatchSize) + 1}: ${saved} formularios guardados (${progress}%)`)

                if ((i / currentBatchSize) % 2 === 1) await yieldToUI()
            } catch (error: any) {
                // Verificar si es error de variables SQL
                if (error.message?.includes('too many SQL variables') && currentBatchSize > 1) {
                    const newBatchSize = Math.floor(currentBatchSize / 2)
                    console.log(`⚠️ Demasiadas variables SQL, reduciendo batch de ${currentBatchSize} a ${newBatchSize}`)
                    currentBatchSize = newBatchSize

                    // Reintentar este chunk con el nuevo tamaño
                    i -= currentBatchSize
                    break
                }

                // Verificar si es error de database lock
                if (error.message?.includes('database is locked') && retryCount < maxRetries) {
                    const waitTime = retryCount * 500
                    console.log(`⏳ Database locked, reintentando en ${waitTime}ms (intento ${retryCount}/${maxRetries})...`)
                    await new Promise((resolve) => setTimeout(resolve, waitTime))
                    continue
                }

                // Error no recuperable
                console.error(`❌ Error guardando formularios Perfect Store batch:`, error)

                if (retryCount >= maxRetries) {
                    console.error(`❌ Máximo de reintentos alcanzado para batch`)
                }

                throw error
            }
        }

        if (!success) {
            throw new Error(`No se pudo guardar el batch después de ${maxRetries} intentos`)
        }
    }

    console.log(`🎉 Total formularios Perfect Store guardados: ${totalSaved}/${data.length}`)
    return totalSaved
}

/**
 * Guarda relaciones entre tiendas y formularios de Perfect Store en lotes optimizados.
 * Utiliza INSERT OR REPLACE para upserts automáticos.
 *
 * @param data - Array de relaciones con estructura {pos_id, forms_ids}
 * @param batchSize - Tamaño del lote (default: 500, se auto-ajusta según límite SQL)
 * @returns Promise<number> - Cantidad total de relaciones guardadas
 *
 * @example
 * const relations = [
 *   { pos_id: 'store1', forms_ids: ['form1', 'form2'] },
 *   { pos_id: 'store2', forms_ids: ['form3'] }
 * ]
 * const saved = await addAllStoresPFRelationBatch(relations, 500)
 * console.log(`${saved} relaciones guardadas`)
 */
export async function addAllStoresPFRelationBatch(data: any[], batchSize = 500): Promise<number> {
    const db = await getDb()
    let totalSaved = 0
    const maxRetries = 5
    let currentBatchSize = batchSize

    // Auto-ajuste para límite SQL: 999 variables / 3 columnas = 333 max
    const MAX_SAFE_BATCH = Math.floor(999 / 3)
    if (currentBatchSize > MAX_SAFE_BATCH) {
        console.log(`⚠️ Batch size ajustado de ${currentBatchSize} a ${MAX_SAFE_BATCH} para evitar límite SQL`)
        currentBatchSize = MAX_SAFE_BATCH
    }

    console.log(`🔄 Iniciando guardado de ${data.length} relaciones Perfect Store en batches de ${currentBatchSize}...`)

    for (let i = 0; i < data.length; i += currentBatchSize) {
        const chunk = data.slice(i, i + currentBatchSize)
        let retryCount = 0
        let success = false

        while (retryCount < maxRetries && !success) {
            retryCount++ // Incrementar al inicio del loop
            try {
                const saved = await db.transaction<number>(async (txn) => {
                    // Construir placeholders: (?,?,?),(?,?,?),...
                    const placeholders = chunk.map(() => '(?,?,?)').join(',')
                    const allParams: any[] = []

                    for (const item of chunk) {
                        allParams.push(
                            item.pos_id, // _id
                            item.pos_id, // pos_id (mismo que _id)
                            JSON.stringify(item.forms_ids || []), // forms_id
                        )
                    }

                    await txn.run({
                        sql: `INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_STORES_PF_RELATION} (
                            _id,
                            pos_id,
                            forms_id
                        ) VALUES ${placeholders}`,
                        params: allParams,
                    })

                    return chunk.length
                })

                totalSaved += saved
                success = true

                // Progress logging cada batch
                const progress = Math.round((totalSaved / data.length) * 100)
                console.log(`✅ Batch ${Math.floor(i / currentBatchSize) + 1}: ${saved} relaciones guardadas (${progress}%)`)

                if ((i / currentBatchSize) % 2 === 1) await yieldToUI()
            } catch (error: any) {
                // retryCount++

                // Error: demasiadas variables SQL
                if (error?.message?.includes('too many SQL variables') && currentBatchSize > 1) {
                    currentBatchSize = Math.floor(currentBatchSize / 2)
                    console.log(`⚠️ Reduciendo batch size a ${currentBatchSize} por límite SQL`)
                    i -= currentBatchSize * 2 // Retroceder para reintentar con nuevo tamaño
                    break
                }

                // Error: database locked
                if (error?.message?.includes('database is locked') && retryCount < maxRetries) {
                    const waitTime = retryCount * 500 // 500ms, 1000ms, 1500ms, 2000ms, 2500ms
                    console.log(`⏳ Database locked, reintentando en ${waitTime}ms... (intento ${retryCount}/${maxRetries})`)
                    await new Promise((resolve) => setTimeout(resolve, waitTime))
                    continue
                }

                // Error no recuperable
                console.error(`❌ Error guardando relation perfect store batch:`, error)

                // Otros errores o máximo de reintentos alcanzado
                if (retryCount >= maxRetries) {
                    console.error(`❌ Error guardando batch después de ${maxRetries} intentos:`, error?.message || error)
                }

                throw error
            }
        }

        if (!success) {
            throw new Error(`No se pudo guardar el batch después de ${maxRetries} intentos`)
        }
    }

    console.log(`🎉 Total de relaciones Perfect Store guardadas: ${totalSaved}/${data.length}`)
    return totalSaved
}

// ============================================================================
// 🆕 UPDATE FORM ANSWERS - Versión moderna y optimizada
// ============================================================================

/**
 * Queue de operaciones para evitar race conditions
 * Garantiza que las operaciones se ejecuten secuencialmente
 */
class FormUpdateQueue {
    private queue: Promise<any> = Promise.resolve()
    private isProcessing = false

    /**
     * Encola una operación para ejecutarse secuencialmente
     */
    async enqueue<T>(operation: () => Promise<T>): Promise<T> {
        const result = this.queue
            .then(() => {
                this.isProcessing = true
                return operation()
            })
            .catch((error) => {
                // Propagar el error pero no bloquear la queue
                throw error
            })
            .finally(() => {
                this.isProcessing = false
            })

        // Actualizar queue para próxima operación
        // Si hay error, la queue continúa (no se bloquea)
        this.queue = result.catch(() => {})

        return result
    }

    /**
     * Verifica si hay operaciones en proceso
     */
    get isPending(): boolean {
        return this.isProcessing
    }
}

// Instancia global de la queue
const formUpdateQueue = new FormUpdateQueue()

/**
 * Tipos para updateFormAnswerSchedule
 */
export interface UpdateFormAnswerInput {
    newAnswer: any
    schedule_id: string
    form_id: string
    store_id?: string | null
    replaceAnswers?: boolean
    clearAnswers?: boolean
    type?: string
    day_unique_id?: string // ✅ Opcional: pasar el day_unique_id del formulario que se abrió
}

export interface UpdateFormAnswerResult {
    status: number
    updatedAnswers?: any[]
    answersCount?: number
    progressPonderacion?: number
    scoreObtained?: number
}

/**
 * Validar day_unique_id
 * Formato esperado: YYMMDD (6 dígitos) - Ejemplo: "250721" para 21/07/2025
 */
function validateDayUniqueId(dayId: string): void {
    if (!dayId || dayId.length !== 6 || !/^\d{6}$/.test(dayId)) {
        throw new Error(`❌ day_unique_id inválido: ${dayId} (se espera formato YYMMDD de 6 dígitos)`)
    }
}

/**
 * Helper: Verificar si una respuesta tiene la opción "NA" seleccionada
 */
function isNaOptionSelected(answer: any): boolean {
    return (
        (answer.option_selected_text && answer.option_selected_text.includes('na')) ||
        (answer.questionOptionSelectedText && answer.questionOptionSelectedText.includes('na'))
    )
}

/**
 * Caché LRU simple para questions parseadas
 * Evita parsear repetidamente las mismas questions
 */
const questionsCache = new Map<string, any[]>()
const CACHE_MAX_SIZE = 50 // Limitar a 50 entradas para evitar memory leaks

function getCachedQuestions(questionsJson: string): any[] {
    if (questionsCache.has(questionsJson)) {
        // Mover al final (LRU)
        const cached = questionsCache.get(questionsJson)!
        questionsCache.delete(questionsJson)
        questionsCache.set(questionsJson, cached)
        return cached
    }

    const parsed = JSON.parse(questionsJson)

    // Si superamos el límite, eliminar el más antiguo (primero del Map)
    if (questionsCache.size >= CACHE_MAX_SIZE) {
        const firstKey = questionsCache.keys().next().value
        questionsCache.delete(firstKey)
    }

    questionsCache.set(questionsJson, parsed)
    return parsed
}

/**
 * Helper: Calcular el progreso de ponderación de un formulario
 *
 * OPTIMIZADO: Un solo pase O(n) usando Maps en lugar de múltiples filters/reduces O(n²)
 *
 * Lógica:
 * 1. Suma scores de respuestas que tienen ponderar=true (excluyendo NA)
 * 2. Considera hide_questions de input_type 14 (dropdowns condicionales)
 * 3. Ajusta score total excluyendo preguntas respondidas con NA
 * 4. Retorna porcentaje (0-100) con 2 decimales
 */
function calculateFormProgress(
    answers: any[],
    questions: any[],
): {
    scoreObtained: number
    scoreTotalQuestionsPonderar: number
    progressPonderacion: number
    scoresByKey?: Record<string, number>
    totalByKey?: Record<string, number>
} {
    // 🚀 OPTIMIZACIÓN: Crear Maps para acceso O(1)
    const questionMap = new Map<string, any>()
    const answerMap = new Map<string, any>()

    // Poblar Maps en un solo pase
    questions.forEach((q) => questionMap.set(q._id, q))
    answers.forEach((a) => answerMap.set(a.question_id, a))

    // Determinar qué respuestas deben ponderarse.
    // Antes solo se consideraba `answer.ponderar === true`, pero hay casos
    // donde la pregunta tiene `secondary_actions[*].scores` y la respuesta
    // debe contribuir al `scoresByKey` aunque `answer.ponderar` sea falsy.
    const answersToPonderate: any[] = []
    const answersIDS: string[] = []
    for (const ans of answers) {
        const q = questionMap.get(ans._id) || questionMap.get(ans.question_id)
        const hasActionScores = !!(
            q &&
            Array.isArray(q.secondary_actions) &&
            q.secondary_actions.some((act: any) => Array.isArray(act.scores) && act.scores.length > 0)
        )

        if (ans.ponderar === true || hasActionScores) {
            answersToPonderate.push(ans)
            answersIDS.push(ans._id)
        }
    }

    // Identificar hide_questions en un solo pase
    const hideQuestionsSet = new Set<string>()

    for (const question of questions) {
        if (question.input_type?.type === 14) {
            const answer = answerMap.get(question._id)
            if (answer?.option_selected_id?.[0]) {
                const selectedAction = question.secondary_actions?.find((action: any) => action._id === answer.option_selected_id[0])
                if (selectedAction?.hide_questions?.length > 0) {
                    selectedAction.hide_questions.forEach((qId: string) => hideQuestionsSet.add(qId))
                }
            }
        }
    }

    // Filtrar preguntas que corresponden a respuestas con ponderar=true
    let cantQuestionPonderar = questions.filter((obj) => answersIDS.includes(obj._id))

    // Para soportar 'scores' por key (plural) vamos a agrupar por key
    const scoresByKey = new Map<string, number>()
    const totalByKey = new Map<string, number>()

    // Precomputar por pregunta el max por key (para total posible)
    const questionKeyMaxMap = new Map<string, Map<string, number>>()
    for (const q of questions) {
        const keyMap = new Map<string, number>()
        // Revisar secondary_actions para encontrar scores por key
        if (Array.isArray(q.secondary_actions)) {
            for (const action of q.secondary_actions) {
                if (Array.isArray(action.scores)) {
                    for (const s of action.scores) {
                        const k = s.key
                        const v = parseFloat(s.value) || 0
                        const prev = keyMap.get(k) || -Infinity
                        // Guardar el máximo por key entre acciones de la misma pregunta
                        if (v > prev) keyMap.set(k, v)
                    }
                }
            }
        }
        if (keyMap.size > 0) questionKeyMaxMap.set(q._id, keyMap)
    }

    // Calcular score total de preguntas a ponderar (manteniendo lógica anterior)
    let scoreTotalQuestionsPonderar = cantQuestionPonderar.reduce((acc, item) => {
        const score = item.questionScore > 0 ? item.questionScore : item.score > 0 ? item.score : 0
        return acc + (parseFloat(score) || 0)
    }, 0)

    // Inicializar totalByKey con la suma de máximos por pregunta (solo para preguntas a ponderar)
    for (const q of cantQuestionPonderar) {
        const keyMap = questionKeyMaxMap.get(q._id)
        if (keyMap) {
            for (const [k, v] of keyMap.entries()) {
                totalByKey.set(k, (totalByKey.get(k) || 0) + v)
            }
        }
    }

    // Calcular score obtenido de las respuestas
    let scoreObtained = 0
    const answersNa: any[] = []

    for (const answer of answers) {
        const isNa = isNaOptionSelected(answer)

        const q = questionMap.get(answer._id) || questionMap.get(answer.question_id)
        const hasActionScores = !!(
            q &&
            Array.isArray(q.secondary_actions) &&
            q.secondary_actions.some((act: any) => Array.isArray(act.scores) && act.scores.length > 0)
        )

        const shouldPonder = answer.ponderar === true || hasActionScores

        if (shouldPonder) {
            if (isNa) {
                answersNa.push(answer)
                continue
            }

            // Preferir score enviado en la respuesta (compatibilidad)
            const numericScore = parseFloat(answer.score) || 0
            
            // Buscar los scores desglosados por key en la acción seleccionada
            if (q && Array.isArray(q.secondary_actions) && Array.isArray(answer.option_selected_id)) {
                const selectedAction = q.secondary_actions.find((act: any) => act._id === answer.option_selected_id[0])
                if (selectedAction && Array.isArray(selectedAction.scores) && selectedAction.scores.length > 0) {
                    // Si hay scores por key, usarlos
                    for (const s of selectedAction.scores) {
                        const k = s.key
                        const v = parseFloat(s.value) || 0
                        scoresByKey.set(k, (scoresByKey.get(k) || 0) + v)
                    }
                }
            }
            
            // Sumar el score al total obtenido
            scoreObtained += numericScore
        }
    }

    // Ajustar por hide_questions
    if (hideQuestionsSet.size > 0) {
        const questionsTransform = questions

        cantQuestionPonderar = questionsTransform.filter((obj) => answersIDS.includes(obj._id) && !hideQuestionsSet.has(obj._id))

        scoreObtained = 0

        const newAnswers = answers.filter((answ) => !hideQuestionsSet.has(answ._id))

        // Resetear agrupaciones por key y recalcular totals respetando hide_questions
        scoresByKey.clear()
        totalByKey.clear()

        // Recalcular totalByKey con preguntas filtradas
        for (const q of cantQuestionPonderar) {
            const keyMap = questionKeyMaxMap.get(q._id)
            if (keyMap) {
                for (const [k, v] of keyMap.entries()) {
                    totalByKey.set(k, (totalByKey.get(k) || 0) + v)
                }
            }
        }

        for (const answer of newAnswers) {
            const q = questionMap.get(answer._id) || questionMap.get(answer.question_id)
            const hasActionScores = !!(
                q &&
                Array.isArray(q.secondary_actions) &&
                q.secondary_actions.some((act: any) => Array.isArray(act.scores) && act.scores.length > 0)
            )

            const shouldPonder = answer.ponderar === true || hasActionScores

            if (!shouldPonder) continue

            const numericScore = parseFloat(answer.score) || 0
            
            // Buscar los scores desglosados por key en la acción seleccionada
            if (q && Array.isArray(q.secondary_actions) && Array.isArray(answer.option_selected_id)) {
                const selectedAction = q.secondary_actions.find((act: any) => act._id === answer.option_selected_id[0])
                if (selectedAction && Array.isArray(selectedAction.scores) && selectedAction.scores.length > 0) {
                    // Si hay scores por key, usarlos
                    for (const s of selectedAction.scores) {
                        const k = s.key
                        const v = parseFloat(s.value) || 0
                        scoresByKey.set(k, (scoresByKey.get(k) || 0) + v)
                    }
                }
            }
            
            // Sumar el score al total obtenido
            scoreObtained += numericScore
        }

        scoreTotalQuestionsPonderar = cantQuestionPonderar.reduce((acc, item) => {
            const score = item.questionScore > 0 ? item.questionScore : item.score > 0 ? item.score : 0
            return acc + (parseFloat(score) || 0)
        }, 0)
    }

    // Ajustar por respuestas NA
    if (answersNa.length > 0) {
        const naQuestionIds = new Set(answersNa.map((answer) => answer.question_id))
        const questionsPonderar = cantQuestionPonderar.filter((question) => !naQuestionIds.has(question._id))

        // Ajustar total por key removiendo preguntas NA
        totalByKey.clear()
        for (const q of questionsPonderar) {
            const keyMap = questionKeyMaxMap.get(q._id)
            if (keyMap) {
                for (const [k, v] of keyMap.entries()) {
                    totalByKey.set(k, (totalByKey.get(k) || 0) + v)
                }
            }
        }

        scoreTotalQuestionsPonderar = questionsPonderar.reduce((acc, item) => {
            const score = item.questionScore > 0 ? item.questionScore : item.score > 0 ? item.score : 0
            return acc + (parseFloat(score) || 0)
        }, 0)
    }

    // Calcular porcentaje
    let progressPonderacion = scoreTotalQuestionsPonderar > 0 ? (scoreObtained * 100) / scoreTotalQuestionsPonderar : 0

    // Redondear a 2 decimales
    if (progressPonderacion % 1 !== 0) {
        progressPonderacion = parseFloat(progressPonderacion.toFixed(2))
    }

    // Validar número válido
    if (!isFinite(progressPonderacion) || isNaN(progressPonderacion)) {
        progressPonderacion = 0
    }

    // Redondear score obtenido
    if (scoreObtained > 0) {
        scoreObtained = parseFloat(scoreObtained.toFixed(2))
    }

    // Convertir maps a objetos planos para retorno
    const scoresByKeyObj: Record<string, number> = {}
    for (const [k, v] of scoresByKey.entries()) scoresByKeyObj[k] = parseFloat(v.toFixed(2))
    const totalByKeyObj: Record<string, number> = {}
    for (const [k, v] of totalByKey.entries()) totalByKeyObj[k] = parseFloat(v.toFixed(2))

 // Nuevos campos opcionales para agrupar scores por key

    return {
        scoreObtained,
        scoreTotalQuestionsPonderar,
        progressPonderacion,
        scoresByKey: scoresByKeyObj,
        totalByKey: totalByKeyObj,
    }
}

/**
 * UPDATE FORM ANSWER SCHEDULE - Versión moderna
 *
 * Mejoras implementadas:
 * - ✅ Queue de operaciones (elimina race conditions)
 * - ✅ Validación de day_unique_id
 * - ✅ Detección de duplicados
 * - ✅ Fingerprints para detectar cambios
 * - ✅ TypeScript con tipos estrictos
 * - ✅ Retry logic con exponential backoff
 * - ✅ Prepared statements (mejor performance)
 * - ✅ Manejo de errores robusto
 * - ✅ Cálculo automático de progress_questions_yes_na (ponderación)
 *
 * @param input - Datos para actualizar el formulario
 * @returns Resultado de la operación
 */
export async function updateFormAnswerSchedule(input: UpdateFormAnswerInput): Promise<UpdateFormAnswerResult> {
    const { newAnswer, schedule_id, form_id, store_id = null, replaceAnswers = false, clearAnswers = false, type = 'null', day_unique_id } = input

    // ✅ Usar queue para evitar race conditions
    return formUpdateQueue.enqueue(async () => {
        // ✅ Envolver la operación en withRetry para manejar "database is locked"
        return withRetry(
            async () => {
                const db = await getDb()

                if (isWeb()) {
                    throw new Error('updateFormAnswerSchedule no soportado en web')
                }

                // ✅ Usar day_unique_id provisto o generar uno nuevo
                // Si el formulario fue abierto con un day_unique_id específico, usarlo
                const dayUniqueId = day_unique_id || generateDayUniqueId()

                // ✅ Validar day_unique_id
                validateDayUniqueId(dayUniqueId)

                // ✅ OPTIMIZACIÓN: Obtener datos FUERA de transacción para reducir lock time
                // Preparar query con o sin store_id
                const selectQuery = store_id
                    ? `SELECT answers, status, date_init, day_unique_id, questions, type_form
                   FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                   WHERE schedule_id = ? 
                     AND form_id = ? 
                     AND store_id = ? 
                     AND day_unique_id = ? 
                     AND status NOT IN (?)
                   ORDER BY date_init DESC
                   LIMIT 1`
                    : `SELECT answers, status, date_init, day_unique_id, questions, type_form
                   FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                   WHERE schedule_id = ? 
                     AND form_id = ? 
                     AND day_unique_id = ? 
                     AND status NOT IN (?, ?)
                   ORDER BY date_init DESC
                   LIMIT 1`

                const selectParams = store_id
                    ? [schedule_id, form_id, store_id, dayUniqueId, FORM_SCHEDULE_STATUS.PENDING_CONNECTION]
                    : [schedule_id, form_id, dayUniqueId, FORM_SCHEDULE_STATUS.COMPLETED, FORM_SCHEDULE_STATUS.PENDING_CONNECTION]
                console.log('SELECT PARAMS ==>', selectParams)
                // ✅ SELECT fuera de transacción (READ no bloquea en WAL mode)
                const result = await db.getFirst<{
                    answers: string
                    status: number
                    date_init: string
                    day_unique_id: string
                    questions: string
                    type_form: string
                }>({
                    sql: selectQuery,
                    params: selectParams,
                })

                if (!result) {
                    console.error('❌ No se encontró registro para:', {
                        schedule_id,
                        form_id,
                        store_id,
                        day_unique_id: dayUniqueId,
                        today: new Date().toISOString().split('T')[0],
                    })
                    throw new Error('No existe registro para hoy')
                }
                // console.log('TENGO Registro ?? ==>', JSON.stringify(result))

                // ✅ Validar que el day_unique_id coincide
                if (result.day_unique_id !== dayUniqueId) {
                    const errorDetails = {
                        expected_day_unique_id: dayUniqueId,
                        found_day_unique_id: result.day_unique_id,
                        schedule_id,
                        form_id,
                        store_id,
                        date_init: result.date_init,
                        current_date: new Date().toISOString(),
                        timezone_offset: new Date().getTimezoneOffset(),
                        mismatch_reason: 'El registro en BD tiene un day_unique_id diferente al calculado hoy',
                    }

                    console.error('❌ VALIDACIÓN FALLIDA: day_unique_id no coincide:', errorDetails)

                    throw new Error(
                        `day_unique_id no coincide: esperado=${dayUniqueId}, encontrado=${result.day_unique_id}. ` +
                            `Esto puede indicar que el registro es de otro día o hay un problema con la generación de day_unique_id.`,
                    )
                }

                // Procesar answers
                let answers = JSON.parse(result.answers || '[]')
                let typeForm = JSON.parse(result.type_form || '{}') 

                if (replaceAnswers) {
                    answers = []
                }

                if (newAnswer && newAnswer._id) {
                    const findIndex = answers.findIndex((a: any) => a._id?.toString() === newAnswer._id?.toString())

                    if (findIndex !== -1) {
                        // Actualizar respuesta existente
                        answers[findIndex] = { ...answers[findIndex], ...newAnswer }
                    } else {
                        // Agregar nueva respuesta
                        answers.push(newAnswer)
                    }
                }

                // Antes de serializar, completar el campo `score` por respuesta si falta,
                // usando secondary_actions[*].scores (plural) o secondary_actions[*].score
                let progressPonderacion = 0
                let scoreObtained = 0

                if (result.questions) {
                    // 🚀 Usar caché para evitar parsear repetidamente
                    const questions = getCachedQuestions(result.questions)

                    // Helper rápido para buscar pregunta por id
                    const questionById = new Map<string, any>()
                    for (const q of questions) questionById.set(q._id, q)

                    for (const ans of answers) {
                        // Si ya tiene score numérico, respetarlo
                        if (ans.score !== undefined && ans.score !== null && ans.score !== '') continue

                        // Intentar inferir score desde la pregunta/secondary_action
                        const q = questionById.get(ans.question_id) || questionById.get(ans._id)
                        if (!q || !Array.isArray(q.secondary_actions) || !Array.isArray(ans.option_selected_id)) continue

                        const sel = q.secondary_actions.find((act: any) => act._id === ans.option_selected_id[0])
                        if (!sel) continue

                        // Priorizar `scores` plural
                        if (Array.isArray(sel.scores) && sel.scores.length > 0) {
                            let sSum = 0
                            for (const s of sel.scores) {
                                sSum += parseFloat(s.value) || 0
                            }
                            ans.score = parseFloat(sSum.toFixed(2))
                        } else if (sel.score !== undefined && sel.score !== null) {
                            ans.score = parseFloat(sel.score) || 0
                        }
                    }

                    // Recalcular progress/score con las respuestas ya enriquecidas
                    const progressData = calculateFormProgress(answers, questions)

                    console.log('Form id =>', form_id)
                    console.log('progressData =>', progressData)
                    // console.log('answers =>', JSON.stringify(answers))
                    // console.log('questions =>', JSON.stringify(questions))

                    progressPonderacion = progressData.progressPonderacion
                    scoreObtained = progressData.scoreObtained

                    // Serializar desglose por key para persistir en BD
                    var scoresByKeyJson = JSON.stringify(progressData.scoresByKey || {})
                    var totalByKeyJson = JSON.stringify(progressData.totalByKey || {})

                    // Serializar las respuestas enriquecidas para persistir en BD
                }

                const updatedAnswers = JSON.stringify(answers)

                // ✅ TRANSACCIÓN ULTRA-CORTA: Solo UPDATEs, sin procesamiento
                return await db.transaction<UpdateFormAnswerResult>(async (txn) => {
                    try {
                        // ✅ FIX: Actualizar estado según cantidad de respuestas
                        // Para formularios repetibles (Promo C, Heladeras):
                        // - Si tienen al menos una respuesta → deben estar en IN_PROGRESS (4)
                        // - Si NO tienen respuestas → deben volver a PENDING (0)
                        const hasAnswers = answers && answers.length > 0

                        let targetStatus: number | null = null
                        let statusReason = ''

                        if (
                            hasAnswers &&
                            result.status !== FORM_SCHEDULE_STATUS.IN_PROGRESS &&
                            result.status !== FORM_SCHEDULE_STATUS.COMPLETED &&
                            result.status !== FORM_SCHEDULE_STATUS.PENDING_CONNECTION
                        ) {
                            // Caso 1: Tiene respuestas pero no está EN CURSO → cambiar a IN_PROGRESS
                            targetStatus = FORM_SCHEDULE_STATUS.IN_PROGRESS
                            statusReason = `tiene ${answers.length} respuesta(s)`
                        } else if (!hasAnswers && result.status === FORM_SCHEDULE_STATUS.IN_PROGRESS && typeForm.type != FORM_TYPES.FORM_POP_HELADERA) { //TODO: si es de type heladera 
                            // Caso 2: NO tiene respuestas pero está EN CURSO → volver a PENDING
                            targetStatus = FORM_SCHEDULE_STATUS.PENDING
                            statusReason = 'sin respuestas (volver a PENDING)'
                        }

                        console.log(`🔍 [updateFormAnswerSchedule] Análisis de estado:`, {
                            hasAnswers,
                            answersCount: answers.length,
                            currentStatus: result.status,
                            targetStatus,
                            willUpdate: targetStatus !== null,
                        })

                        if (targetStatus !== null) {
                            await updateFormStatusInTransaction(
                                txn,
                                schedule_id,
                                form_id,
                                store_id,
                                targetStatus,
                                dayUniqueId,
                                `opcion:${type} - ${statusReason}`,
                            )
                            console.log(`✅ [updateFormAnswerSchedule] Status cambiado de ${result.status} a ${targetStatus} (${statusReason})`, {
                                schedule_id,
                                form_id,
                                store_id,
                                targetStatus,
                                statusReason,
                                answers,
                                caller: new Error().stack,
                            })
                        } else {
                            // console.log(
                            //     `⏭️ [updateFormAnswerSchedule] Status no se actualiza - hasAnswers: ${hasAnswers}, status actual: ${result.status}`,
                            //     {
                            //         schedule_id,
                            //         form_id,
                            //         store_id,
                            //         answers,
                            //         caller: new Error().stack,
                            //     },
                            // )
                        }

                        // ✅ Update answers + progress (única operación crítica)
                        // Verificar si las columnas `scoresByKey` y `totalByKey` existen en la tabla
                        const tableInfo = await txn.getAll<any>({ sql: `PRAGMA table_info(${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS})` })
                        const columnNames = (tableInfo || []).map((c: any) => c.name)
                        const hasScoresColumns = columnNames.includes('scoresByKey') && columnNames.includes('totalByKey')

                        let updateQuery: string
                        let updateParams: any[]

                        if (store_id) {
                            if (hasScoresColumns) {
                                updateQuery = `UPDATE ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                                   SET answers = ?, 
                                       progress_questions_yes_na = ?,
                                       scoreObtainedFloat = ?,
                                       scoresByKey = ?,
                                       totalByKey = ?
                                   WHERE schedule_id = ? 
                                     AND form_id = ? 
                                     AND store_id = ? 
                                     AND day_unique_id = ? 
                                     AND status NOT IN (?)`

                                updateParams = [
                                    updatedAnswers,
                                    progressPonderacion,
                                    scoreObtained,
                                    scoresByKeyJson,
                                    totalByKeyJson,
                                    schedule_id,
                                    form_id,
                                    store_id,
                                    dayUniqueId,
                                    FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                                ]
                            } else {
                                // Columnas no presentes: omitir scoresByKey/totalByKey
                                updateQuery = `UPDATE ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                                   SET answers = ?, 
                                       progress_questions_yes_na = ?,
                                       scoreObtainedFloat = ?
                                   WHERE schedule_id = ? 
                                     AND form_id = ? 
                                     AND store_id = ? 
                                     AND day_unique_id = ? 
                                     AND status NOT IN (?)`

                                updateParams = [
                                    updatedAnswers,
                                    progressPonderacion,
                                    scoreObtained,
                                    schedule_id,
                                    form_id,
                                    store_id,
                                    dayUniqueId,
                                    FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                                ]
                            }
                        } else {
                            if (hasScoresColumns) {
                                updateQuery = `UPDATE ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                                   SET answers = ?,
                                       progress_questions_yes_na = ?,
                                       scoreObtainedFloat = ?,
                                       scoresByKey = ?,
                                       totalByKey = ?
                                   WHERE schedule_id = ? 
                                     AND form_id = ? 
                                     AND day_unique_id = ? 
                                     AND status NOT IN (?, ?)`

                                updateParams = [
                                    updatedAnswers,
                                    progressPonderacion,
                                    scoreObtained,
                                    scoresByKeyJson,
                                    totalByKeyJson,
                                    schedule_id,
                                    form_id,
                                    dayUniqueId,
                                    FORM_SCHEDULE_STATUS.COMPLETED,
                                    FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                                ]
                            } else {
                                // Columnas no presentes: omitir scoresByKey/totalByKey
                                updateQuery = `UPDATE ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                                   SET answers = ?,
                                       progress_questions_yes_na = ?,
                                       scoreObtainedFloat = ?
                                   WHERE schedule_id = ? 
                                     AND form_id = ? 
                                     AND day_unique_id = ? 
                                     AND status NOT IN (?, ?)`

                                updateParams = [
                                    updatedAnswers,
                                    progressPonderacion,
                                    scoreObtained,
                                    schedule_id,
                                    form_id,
                                    dayUniqueId,
                                    FORM_SCHEDULE_STATUS.COMPLETED,
                                    FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                                ]
                            }
                        }

                        const updateResult = await txn.run({
                            sql: updateQuery,
                            params: updateParams,
                        })
                        

                        // ✅ Validar que el UPDATE afectó al menos 1 fila
                        if (!updateResult.changes || updateResult.changes === 0) {
                            const errorDetails = {
                                schedule_id,
                                form_id,
                                store_id,
                                day_unique_id: dayUniqueId,
                                status_current: result.status,
                                answers_count: answers.length,
                                rows_affected: updateResult.changes,
                                query_conditions: store_id ? `store_id=${store_id}, day_unique_id=${dayUniqueId}` : `day_unique_id=${dayUniqueId}`,
                                possible_cause: 'El WHERE del UPDATE no coincidió con ningún registro',
                            }

                            console.error('❌ UPDATE no afectó ninguna fila:', errorDetails)

                            throw new Error(
                                `No se pudo actualizar el formulario: 0 filas afectadas. ` +
                                    `Posibles causas: status cambió a PENDING_CONNECTION, day_unique_id no coincide, o registro fue eliminado.`,
                            )
                        }

                        console.log('✅ Formulario actualizado:', {
                            form_id,
                            answersCount: answers.length,
                            progressPonderacion: `${progressPonderacion}%`,
                            scoreObtained,
                            day_unique_id: dayUniqueId,
                            rows_affected: updateResult.changes,
                        })

                        return {
                            status: 1,
                            updatedAnswers: answers,
                            answersCount: answers.length,
                            progressPonderacion,
                            scoreObtained,
                        }
                    } catch (error: any) {
                        console.error('❌ Error en updateFormAnswerSchedule:', {
                            error: error.message,
                            schedule_id,
                            form_id,
                            store_id,
                            day_unique_id: dayUniqueId,
                        })
                        throw error
                    }
                })
            },
            5,
            500,
        ) // ✅ 5 reintentos con 500ms de delay inicial
    })
}

/**
 * Actualizar status de formulario dentro de una transacción
 * Helper function para updateFormAnswerSchedule
 */
async function updateFormStatusInTransaction(
    txn: any, // Transaction object
    schedule_id: string,
    form_id: string,
    store_id: string | null,
    status: number,
    dayUniqueId: string,
    note: string = '',
): Promise<void> {
    const query = store_id
        ? `UPDATE ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
           SET status = ?
           WHERE schedule_id = ? 
             AND form_id = ? 
             AND store_id = ? 
             AND day_unique_id = ?`
        : `UPDATE ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
           SET status = ?
           WHERE schedule_id = ? 
             AND form_id = ? 
             AND day_unique_id = ?`

    const params = store_id ? [status, schedule_id, form_id, store_id, dayUniqueId] : [status, schedule_id, form_id, dayUniqueId]

    const result = await txn.run({
        sql: query,
        params,
    })

    console.log(`✅ [updateFormStatusInTransaction] Status actualizado a ${status} - ${note} - Rows affected: ${result.changes}`)
}

/**
 * 🆕 NUEVA IMPLEMENTACIÓN TYPESCRIPT
 *
 * Obtiene un formulario guardado en FORMS_QUESTION_ANSWERS filtrado por día de hoy.
 * Esta función reemplaza la implementación antigua de schedules.database.js
 *
 * ✅ Mejoras aplicadas:
 * - Tipado TypeScript para type safety
 * - Mejor manejo de errores con tipos específicos
 * - Validación de day_unique_id
 * - Performance optimizada (queries más eficientes)
 * - Sin JSON.parse redundante (ya parseado en BD)
 * - Soporte completo para web y native
 *
 * 🔄 LÓGICA PARA FORMULARIOS REPETIBLES (repeat=1):
 * - Busca TODOS los registros del día de hoy (sin filtrar por status)
 * - Prioriza registros EN PROGRESO (status != COMPLETED/PENDING_CONNECTION)
 * - Si solo hay registros completados, retorna el más reciente CON SU STATUS REAL
 * - Esto permite:
 *   ✓ Durante el flujo: Encontrar el formulario en progreso
 *   ✓ Después del checkout offline: Mostrar el status correcto (PENDING_CONNECTION)
 *
 * @param schedule_id - ID del schedule
 * @param form_id - ID del formulario
 * @param store_id - ID de la tienda (opcional)
 * @param register_id - ID del registro específico (opcional, bypasses otras condiciones)
 * @param repeat - Flag de repetición (1 = formulario repetible)
 * @returns Promise con los datos del formulario o estructura vacía
 */
export async function getFormsAnswersInStore(
    schedule_id: string,
    form_id: string,
    store_id: string | null = null,
    register_id: string | null = null,
    repeat: number | null = null,
): Promise<{
    fqa_id?: string
    answers: any[]
    date_init: string | null
    date_finish?: string | null
    status?: number
    repeat?: number
    totalScore?: number
    scoreObtained?: number
    cant_questions_yes_na?: number
    progress_questions_yes_na?: number
    scoreTotalQuestionsPonderar?: number
    name_form?: string
    questions?: any[]
    heladera?: any
    create_refrigerator?: any
    type_form?: any
    form_id_father?: string
    form?: null
}> {
    try {
        const db = await getDb()

        if (isWeb()) {
            // 🌐 WEB: IndexedDB implementation
            // TODO: Implementar correctamente para web cuando sea necesario
            // Por ahora retornamos estructura vacía
            console.warn('⚠️ getFormsAnswersInStore en web aún no implementado completamente')
            return {
                answers: [],
                date_init: null,
                form: null,
            }
        } else {
            // 📱 NATIVE: SQLite implementation
            const generateIdDate = generateDayUniqueId()
            // console.log('🔍 Buscando formulario con day_unique_id:', generateIdDate)

            // ✅ Validar day_unique_id (debe ser YYMMDD - 6 caracteres)
            if (!generateIdDate || generateIdDate.length !== 6) {
                throw new Error(`❌ day_unique_id inválido: ${generateIdDate} (esperado: YYMMDD de 6 dígitos)`)
            }

            let query: string
            let queryParams: any[]

            // 🔍 Construir query según parámetros
            if (register_id) {
                // Caso 1: Buscar por ID específico de registro
                query = `
                    SELECT _id, answers, date_init, date_finish, repeat, status, totalScore, 
                           scoreObtainedFloat, cant_questions_yes_na, progress_questions_yes_na, 
                           scoreTotalQuestionsPonderarFloat, name_form, questions, heladera, 
                           create_refrigerator, type_form, form_id_father
                    FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                    WHERE _id = ?
                `
                queryParams = [register_id]
            } else if (store_id) {
                if (repeat && repeat === 1) {
                    // Caso 2: Formulario repetible - buscar TODOS los del día de hoy
                    // ✅ NO excluir por status para poder encontrar tanto en progreso como completados
                    query = `
                        SELECT _id, answers, date_init, date_finish, repeat, status, totalScore, 
                               scoreObtainedFloat, cant_questions_yes_na, progress_questions_yes_na, 
                               scoreTotalQuestionsPonderarFloat, name_form, questions, heladera, 
                               create_refrigerator, type_form, form_id_father
                        FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                        WHERE schedule_id = ? AND form_id = ? AND store_id = ? 
                          AND date(date_init) = date('now')
                        ORDER BY 
                          CASE 
                            WHEN status NOT IN (${FORM_SCHEDULE_STATUS.COMPLETED}, ${FORM_SCHEDULE_STATUS.PENDING_CONNECTION}) THEN 0
                            ELSE 1
                          END,
                          date_init DESC
                    `
                    queryParams = [schedule_id, form_id, store_id]
                } else {
                    // Caso 3: Formulario normal - buscar por day_unique_id
                    query = `
                        SELECT _id, answers, date_init, date_finish, repeat, status, totalScore, 
                               scoreObtainedFloat, cant_questions_yes_na, progress_questions_yes_na, 
                               scoreTotalQuestionsPonderarFloat, name_form, questions, heladera, 
                               create_refrigerator, type_form, form_id_father
                        FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                        WHERE schedule_id = ? AND form_id = ? AND store_id = ? AND day_unique_id = ?
                    `
                    queryParams = [schedule_id, form_id, store_id, generateIdDate]
                }
            } else {
                // Caso 4: Sin store_id - buscar por schedule y form
                query = `
                    SELECT _id, answers, date_init, date_finish, repeat, status, totalScore, 
                           scoreObtainedFloat, cant_questions_yes_na, progress_questions_yes_na, 
                           scoreTotalQuestionsPonderarFloat, name_form, questions, heladera, 
                           create_refrigerator, type_form, form_id_father
                    FROM ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS}
                    WHERE schedule_id = ? AND form_id = ? AND day_unique_id = ? 
                      AND status NOT IN (${FORM_SCHEDULE_STATUS.COMPLETED}, ${FORM_SCHEDULE_STATUS.PENDING_CONNECTION})
                `
                queryParams = [schedule_id, form_id, generateIdDate]
            }

            // console.log('🔍 Ejecutando query getFormsAnswersInStore:', { query, queryParams })
            // 🎯 Ejecutar query usando el adapter correcto
            const rows = await db.getAll<any>({ sql: query, params: queryParams })

            // 📦 Procesar resultado
            if (rows && rows.length > 0) {
                // ✅ Para formularios repetibles con múltiples registros del día de hoy:
                // - El ORDER BY ya priorizó los registros en progreso (status != COMPLETED/PENDING_CONNECTION)
                // - Tomamos el primero: será el en progreso si existe, o el más reciente completado si todos están completados
                const rowToday = rows[0]

                console.log('🔍 DEBUG getFormsAnswersInStore (repository) - rowToday RAW:', {
                    _id: rowToday._id,
                    status: rowToday.status,
                    repeat: rowToday.repeat,
                    total_rows: rows.length,
                    heladera: rowToday.heladera,
                    heladera_type: typeof rowToday.heladera,
                    form_id_father: rowToday.form_id_father,
                    form_id_father_type: typeof rowToday.form_id_father,
                    create_refrigerator: rowToday.create_refrigerator,
                })

                // ✅ IMPORTANTE: Ya viene parseado desde BD, NO hacer JSON.parse() de nuevo
                // Verificar si ya es objeto o necesita parse
                const answers = typeof rowToday.answers === 'string' ? JSON.parse(rowToday.answers) : rowToday.answers

                const questions = typeof rowToday.questions === 'string' ? JSON.parse(rowToday.questions) : rowToday.questions

                const type_form = typeof rowToday.type_form === 'string' ? JSON.parse(rowToday.type_form) : rowToday.type_form

                const result = {
                    fqa_id: rowToday._id,
                    answers: answers,
                    date_init: rowToday.date_init,
                    date_finish: rowToday.date_finish,
                    status: rowToday.status,
                    repeat: rowToday.repeat,
                    totalScore: rowToday.totalScore,
                    scoreObtained: rowToday.scoreObtainedFloat,
                    cant_questions_yes_na: rowToday.cant_questions_yes_na,
                    progress_questions_yes_na: rowToday.progress_questions_yes_na,
                    scoreTotalQuestionsPonderar: rowToday.scoreTotalQuestionsPonderarFloat,
                    name_form: rowToday.name_form,
                    questions: questions,
                    heladera: rowToday.heladera,
                    create_refrigerator: rowToday.create_refrigerator,
                    type_form: type_form,
                    form_id_father: rowToday.form_id_father,
                }

                console.log(`📤 [getFormsAnswersInStore] Retornando formulario:`, {
                    fqa_id: result.fqa_id,
                    status: result.status,
                    progress: result.progress_questions_yes_na,
                    answers_count: result.answers.length,
                })

                return result
            } else {
                // ℹ️ No se encontró registro - retornar estructura vacía
                return {
                    answers: [],
                    date_init: null,
                    form: null,
                }
            }
        }
    } catch (error) {
        console.error('❌ Error en getFormsAnswersInStore (repository):', error)
        throw error
    }
}

/**
 * Retry wrapper con exponential backoff
 * Útil para manejar database locks
 */
export async function withRetry<T>(operation: () => Promise<T>, maxRetries: number = 5, baseDelay: number = 500): Promise<T> {
    for (let attempt = 0; attempt < maxRetries; attempt++) {
        try {
            return await operation()
        } catch (error: any) {
            const isDatabaseLocked = error.message?.includes('database is locked')

            if (!isDatabaseLocked || attempt === maxRetries - 1) {
                throw error
            }

            // Exponential backoff: 500ms, 1000ms, 2000ms, 4000ms, 8000ms
            const delay = baseDelay * Math.pow(2, attempt)
            console.warn(`⚠️ Database locked, retry ${attempt + 1}/${maxRetries} in ${delay}ms`)
            await new Promise((resolve) => setTimeout(resolve, delay))
        }
    }

    throw new Error('Max retries reached')
}

// ============================================================================
// 📊 SCHEDULE ADVANCES
// ============================================================================

/**
 * Interface para Schedule Advance
 */
interface ScheduleAdvance {
    _id: string
    pos_id?: string | null
    schedule_id: string
    forms?: any[]
    status: number
    date_init: string
    form_id?: string
    progress?: number
    score?: number
    checkin_id?: string
    date_modified: string
    distributor_id?: string
    objectives?: any[]
    incidence_answer?: string | null
    recover_forms?: boolean
}

/**
 * Inserta o actualiza múltiples registros de schedule advances en batch
 *
 * @param advancesSchedules - Array de schedule advances a insertar
 * @returns Promise con el resultado de la operación
 *
 * IMPORTANTE:
 * - Usa INSERT OR REPLACE para manejar duplicados
 * - Maneja batches grandes dividiendo recursivamente si hay error de SQL variables
 * - Serializa automáticamente arrays como forms y objectives a JSON
 */
export async function addAdvancesSchedules(advancesSchedules: ScheduleAdvance[]): Promise<any> {
    console.log('🚀 Iniciando addAdvancesSchedules... en schedule.repository => ')
    if (isWeb()) {
        console.warn('⚠️ addAdvancesSchedules no soportado en web aún')
        return null
    }

    if (!advancesSchedules || advancesSchedules.length === 0) {
        console.log('ℹ️ No hay schedule advances para insertar')
        return null
    }

    console.log(`📊 Insertando ${advancesSchedules.length} schedule advances...`)

    try {
        const db = await getDb()

        // Construir placeholders y valores
        const placeholders = advancesSchedules.map(() => '(?,?,?,?,?,?,?,?,?,?,?,?,?,?)').join(',')
        const values = advancesSchedules.flatMap((schedule) => [
            schedule._id,
            schedule.pos_id || null,
            schedule.schedule_id,
            JSON.stringify(schedule.forms || []),
            schedule.status,
            schedule.date_init,
            schedule.form_id || '',
            schedule.progress || 0,
            schedule.score || 0,
            schedule.checkin_id || '',
            schedule.date_modified,
            schedule.distributor_id || '',
            JSON.stringify(schedule.objectives || []),
            schedule.incidence_answer || null,
        ])

        const query = `INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_ADVANCES} (
            _id,
            pos_id,
            schedule_id,
            forms,
            status,
            date_init,
            form_id,
            progress,
            score,
            checkin_id,
            date_modified,
            distributor_id,
            objectives,
            incidence_answer
        ) VALUES ${placeholders}`

        // Ejecutar con retry en caso de lock
        const result = await withRetry(
            async () => {
                // return await db.run(query, values)
                return await db.run({
                    sql: query,
                    params: values,
                })
            },
            5,
            500,
        )

        console.log(`✅ ${advancesSchedules.length} schedule advances insertados correctamente`)
        return result
    } catch (error: any) {
        // Si el error es por demasiadas variables SQL, lanzamos para que insertInBatches lo maneje
        if (error.message?.includes('SQLITE_ERROR') || error.message?.includes('too many SQL variables')) {
            console.warn(`⚠️ Error de SQL variables con ${advancesSchedules.length} registros, necesita división`)
            throw error
        }

        console.error('❌ Error en addAdvancesSchedules:', error)
        throw error
    }
}

/**
 * Inserta schedule advances en batches con manejo recursivo de errores
 *
 * Si falla por exceso de variables SQL, divide el batch en 2 mitades y reintenta recursivamente
 *
 * @param data - Array de schedule advances
 * @param chunkSize - Tamaño sugerido del chunk (se reduce automáticamente si falla)
 */
export async function insertAdvancesInBatches(data: ScheduleAdvance[], chunkSize: number): Promise<void> {
    try {
        // Intentamos insertar el batch completo
        await addAdvancesSchedules(data)
    } catch (error: any) {
        // Verificamos si es un error de tamaño
        if ((error.message?.includes('SQLITE_ERROR') || error.message?.includes('too many SQL variables')) && chunkSize > 1) {
            console.warn(`⚠️ Dividiendo batch de ${data.length} en 2 mitades...`)

            // Reducimos el tamaño del lote y tratamos de nuevo
            const middle = Math.ceil(data.length / 2)
            const firstHalf = data.slice(0, middle)
            const secondHalf = data.slice(middle)

            // Recursivamente llamamos a la función para cada mitad
            await insertAdvancesInBatches(firstHalf, Math.floor(chunkSize / 2))
            await insertAdvancesInBatches(secondHalf, Math.floor(chunkSize / 2))
        } else {
            // Si el chunkSize es 1 o no es un error de tamaño, lanzamos el error
            console.error('❌ No se pudo insertar el batch:', error.message)
            throw error
        }
    }
}

/**
 * Actualiza el status_send de un formulario en FORMS_PENDING_SYNC
 *
 * Determina si el formulario debe sincronizarse o no.
 *
 * @param schedule_id - ID del schedule
 * @param activity_id - ID de la actividad/formulario
 * @param status_send - Nuevo estado de sincronización
 *
 * @returns Promise<any> - Resultado de la actualización
 *
 * @example
 * await updateFormPendingSyncStatusSend('sch_123', 'form_456', 1)
 */
export async function updateFormPendingSyncStatusSend(schedule_id: string, activity_id: string, status_send: number): Promise<any> {
    if (isWeb()) {
        console.warn('⚠️ updateFormPendingSyncStatusSend no soportado en web')
        return null
    }

    try {
        const db = await getDb()

        const query = `
            UPDATE ${TABLE_NAME.SCHEDULE_FORMS_PENDING_SYNC} 
            SET status_send = ?, 
                date = datetime('now', 'localtime')
            WHERE schedule_id = ? 
              AND activity_id = ?
        `

        const params = [status_send, schedule_id, activity_id]

        const result = await db.run({ sql: query, params })

        // console.log(`✅ Form pending sync status actualizado: ${activity_id} -> ${status_send}`)
        return result
    } catch (error) {
        console.error('❌ Error al actualizar form pending sync status:', error)
        throw error
    }
}

/**
 * Obtiene la información para crear tiendas desde CREATE_STORES
 *
 * @returns Promise con los datos de configuración para crear tiendas
 *
 * @example
 * const info = await getInfoCreateStores()
 * console.log(info.areas, info.forms)
 */
export async function getInfoCreateStores(): Promise<any> {
    if (isWeb()) {
        console.warn('⚠️ getInfoCreateStores no soportado en web')
        return null
    }

    try {
        const db = await getDb()

        const query = `SELECT * FROM ${TABLE_NAME.SCHEDULE_CREATE_STORES}`
        const result = await db.getFirst({ sql: query, params: [] })

        console.log('✅ Info create stores obtenida')
        return result
    } catch (error) {
        console.error('❌ Error al obtener info create stores:', error)
        throw error
    }
}

/**
 * Interface para los datos de una tienda local
 */
export interface StoreLocalData {
    schedule_id: string
    name: string
    lat: number | string
    lng: number | string
    address?: string
    code?: string
    cluster?: string
    area?: string
    region?: string
    format?: string
    flag?: string
    maximum_distance_for_checking?: string
    store_segment?: string
    distributor_id?: string | null
}

/**
 * Agrega una tienda local con su relación a SCHEDULES_POS y STORES
 *
 * Crea un ID único para la tienda y la inserta en ambas tablas.
 *
 * @param data - Datos de la tienda a crear
 * @param forms - Array de IDs de formularios asociados
 *
 * @returns Promise con el resultado de la inserción
 *
 * @example
 * const result = await addStoreLocal({
 *   schedule_id: 'sch_123',
 *   name: 'Tienda Nueva',
 *   lat: 19.4326,
 *   lng: -99.1332
 * }, ['form_1', 'form_2'])
 */
export async function addStoreLocal(data: StoreLocalData, forms: string[] = []): Promise<any> {
    if (!data) {
        throw new Error('Data is required')
    }

    if (isWeb()) {
        console.warn('⚠️ addStoreLocal no soportado en web')
        return null
    }

    try {
        const db = await getDb()

        // Generar ID único para la nueva tienda
        const newId = `local_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`

        // 1. Insertar en SCHEDULES_POS
        const posQuery = `
            INSERT INTO ${TABLE_NAME.SCHEDULES_POS} 
            (_id, store_id, schedule_id, forms, forms_relevant, forms_featured, campaign_status, lat, lng, existsInDB) 
            VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        `

        const posParams = [
            newId,
            newId,
            data.schedule_id,
            JSON.stringify(forms),
            JSON.stringify([]),
            JSON.stringify([]),
            FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
            data.lat,
            data.lng,
            0, // false
        ]

        // await db.run(posQuery, posParams)
        const insertSchedulePosResult = await db.run({ sql: posQuery, params: posParams })
        console.log('✅ POS entry agregado:', newId, 'insertSchedulePosResult => ', insertSchedulePosResult)

        // 2. Insertar en STORES
        const storeQuery = `
            INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_STORES} 
            (_id, name, address, lat, lng, code, cluster, area, region, format, flag, maximum_distance_for_checkin, segment, distributor_id, existsInDB) 
            VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        `

        const storeParams = [
            newId,
            data.name,
            data.address || '',
            parseFloat(String(data.lat || 0)),
            parseFloat(String(data.lng || 0)),
            data.code || '',
            data.cluster || '',
            data.area || '',
            data.region || '',
            data.format || '',
            data.flag || '',
            data.maximum_distance_for_checking || '',
            data.store_segment || '',
            data.distributor_id || null,
            0, // false
        ]

        const result = await db.run({ sql: storeQuery, params: storeParams })
        console.log('✅ Store entry agregado:', newId, 'result => ', result)

        return {
            ...result,
            storeId: newId,
        }
    } catch (error) {
        console.error('❌ Error al agregar store local:', error)
        throw error
    }
}

//fn para validar si existe una tienda en local por nombre
export async function checkStoreLocalByName(schedule_id: string, name: string): Promise<boolean> {
    if (isWeb()) {
        console.warn('⚠️ checkStoreLocalByName no soportado en web')
        return false
    }

    try {
        const db = await getDb()

        // const query = `
        //     SELECT COUNT(*) as count
        //     FROM ${TABLE_NAME.SCHEDULE_STORES} s
        //     JOIN ${TABLE_NAME.SCHEDULES_POS} p ON s._id = p.store_id
        //     WHERE p.schedule_id = ? AND s.name = ?
        // `

        const query = `
            SELECT COUNT(*) as count 
            FROM ${TABLE_NAME.SCHEDULE_STORES} s
            WHERE s.name = ?
        `

        const params = [name]

        const result = await db.getFirst<{ count: number }>({ sql: query, params })

        const exists = result ? result.count > 0 : false
        console.log(`🔍 Store local "${name}" exists:`, exists)
        return exists
    } catch (error) {
        console.error('❌ Error al verificar store local por nombre:', error)
        throw error
    }
}

/**
 * 🆕 FUNCIÓN MIGRADA DESDE schedules.database.js
 *
 * Obtiene el estado de progreso de un formulario desde SCHEDULES_ADVANCES
 *
 * @description Busca el registro de advance para un formulario específico de agenda
 * @param {string} schedule_id - ID del schedule
 * @param {string} form_id - ID del formulario (para forms de agenda matutino/vespertino)
 * @param {string} dateSelected - Fecha seleccionada (actualmente no se usa en la query)
 * @returns {Promise<any | null>} Registro del advance o null si no se encuentra
 */
export async function getFormStatusFromAdvances(schedule_id: string, form_id: string, dateSelected?: string): Promise<any | null> {
    if (isWeb()) {
        console.warn('⚠️ getFormStatusFromAdvances no está implementado para web')
        return null
    }

    if (!form_id) {
        console.log('ℹ️ No se proporcionó form_id, retornando null')
        return null
    }

    const db = await getDb()

    try {
        const result = await db.getFirst<any>({
            sql: `SELECT * FROM ${TABLE_NAME.SCHEDULE_ADVANCES} 
                  WHERE schedule_id = ? AND form_id = ?`,
            params: [schedule_id, form_id],
        })

        if (result) {
            console.log(`✅ Form status encontrado para form_id: ${form_id}`)
            // Deserializar JSON fields si existen
            return {
                ...result,
                forms: result.forms ? JSON.parse(result.forms) : [],
                objectives: result.objectives ? JSON.parse(result.objectives) : [],
            }
        } else {
            console.log(`ℹ️ No se encontró advance para schedule_id: ${schedule_id}, form_id: ${form_id}`)
            return null
        }
    } catch (error) {
        console.error('❌ Error en getFormStatusFromAdvances:', error)
        throw error
    }
}

/**
 * 🆕 FUNCIÓN MIGRADA DESDE schedules.database.js
 *
 * Inserta o actualiza el estado de un formulario en SCHEDULES_ADVANCES
 *
 * @description Realiza un UPSERT (UPDATE o INSERT) del estado de progreso de un formulario
 * Mejoras respecto a la versión anterior:
 * - ✅ Usa transacción nativa del adapter para mejor atomicidad
 * - ✅ Una sola query en lugar de UPDATE + INSERT condicional
 * - ✅ Mejor performance con INSERT OR REPLACE
 * - ✅ Genera date_modified automáticamente
 * - ✅ Tipado fuerte TypeScript
 *
 * @param {string} schedule_id - ID del schedule
 * @param {string} form_id - ID del formulario
 * @param {number} newStatus - Nuevo estado del formulario
 * @param {string} dateInit - Fecha de inicio
 * @param {number} progress - Progreso del formulario (0-100)
 * @param {number} scoreObtained - Puntaje obtenido
 * @returns {Promise<{ success: boolean; action: 'inserted' | 'updated'; rowId?: number }>}
 */
export async function upsertFormStatus(
    schedule_id: string,
    form_id: string,
    newStatus: number,
    dateInit: string,
    progress: number,
    scoreObtained: number,
): Promise<{ success: boolean; action: 'inserted' | 'updated'; rowId?: number }> {
    console.log(
        `🚀 Iniciando upsertFormStatus: schedule_id=${schedule_id}, form_id=${form_id}, status=${newStatus}, progress=${progress}, scoreObtained=${scoreObtained}`,
    )
    console.log('typeof parameters:', { progress: typeof progress, scoreObtained: typeof scoreObtained })
    if (isWeb()) {
        console.warn('⚠️ upsertFormStatus no está implementado para web')
        return { success: false, action: 'inserted' }
    }

    if (!schedule_id || !form_id) {
        throw new Error('schedule_id y form_id son requeridos')
    }

    // ✅ Usar withRetry para manejar "database is locked"
    return withRetry(
        async () => {
            const db = await getDb()

            try {
                return await db.transaction(async (txn) => {
                    // 🔍 Primero verificar si existe el registro
                    const existing = await txn.getFirst<{ _id: string }>({
                        sql: `SELECT _id FROM ${TABLE_NAME.SCHEDULE_ADVANCES} 
                          WHERE schedule_id = ? AND form_id = ?`,
                        params: [schedule_id, form_id],
                    })

                    const date_modified = new Date().toISOString()

                    console.log(`🔍 Registro existente: ${existing ? 'Sí' : 'No'}`)

                    if (existing) {
                        // ✅ UPDATE: Registro existe
                        await txn.run({
                            sql: `UPDATE ${TABLE_NAME.SCHEDULE_ADVANCES}
                              SET status = ?, 
                                  progress = ?, 
                                  score = ?,
                                  date_modified = ?
                              WHERE schedule_id = ? AND form_id = ?`,
                            params: [newStatus, progress, scoreObtained, date_modified, schedule_id, form_id],
                        })

                        console.log(`✅ Form status actualizado: schedule_id=${schedule_id}, form_id=${form_id}, status=${newStatus}`)
                        return { success: true, action: 'updated' as const }
                    } else {
                        // ✅ INSERT: Registro no existe
                        const newId = generateUniqueId()

                        const result = await txn.run({
                            sql: `INSERT INTO ${TABLE_NAME.SCHEDULE_ADVANCES}
                              (_id, schedule_id, form_id, status, date_init, progress, score, date_modified, forms, objectives)
                              VALUES (?, ?, ?, ?, ?, ?, ?, ?, '[]', '[]')`,
                            params: [newId, schedule_id, form_id, newStatus, dateInit, progress, scoreObtained, date_modified],
                        })

                        console.log(`✅ Form status insertado: _id=${newId}, schedule_id=${schedule_id}, form_id=${form_id}, status=${newStatus}`)
                        return { success: true, action: 'inserted' as const, rowId: result.lastInsertRowId }
                    }
                })
            } catch (error) {
                console.error('❌ Error en upsertFormStatus:', error)
                throw error
            }
        },
        5,
        500,
    ) // 5 reintentos con 500ms base delay
}

/**
 * Genera un ID único en formato UUID v4
 * @returns {string} UUID v4
 */
function generateUniqueId(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0
        const v = c === 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
    })
}

/**
 * ✅ Verifica si ya existen heladeras creadas o auditadas en el checkin actual
 * @param checkin_id - ID del checkin actual
 * @param store_id - ID de la tienda
 * @returns {Promise<boolean>} true si hay heladeras creadas/auditadas, false si no
 */
export async function hasRefrigeratorsInCurrentCheckin(checkin_id: string, store_id: string): Promise<boolean> {
    if (isWeb()) {
        console.warn('⚠️ hasRefrigeratorsInCurrentCheckin no está implementado para web')
        return false
    }

    if (!checkin_id || !store_id) {
        console.log('ℹ️ No se proporcionó checkin_id o store_id')
        return false
    }

    const db = await getDb()

    try {
        // Buscar formularios de heladeras (create_refrigerator = 1) en el checkin actual
        const result = await db.getAll<any>({
            sql: `SELECT COUNT(*) as count FROM ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} 
                  WHERE checkin_id = ? 
                  AND store_id = ? 
                  AND (create_refrigerator = 1 OR heladera = 1)`,
            params: [checkin_id, store_id],
        })

        const count = result[0]?.count || 0
        const hasRefrigerators = count > 0

        console.log(`🔍 hasRefrigeratorsInCurrentCheckin: ${hasRefrigerators} (count: ${count}) para checkin_id: ${checkin_id}`)
        
        return hasRefrigerators
    } catch (error) {
        console.error('❌ Error en hasRefrigeratorsInCurrentCheckin:', error)
        return false
    }
}

// ============================================================================
// 🔄 STORE UPDATES - Actualización de IDs de tiendas
// ============================================================================

/**
 * 🆕 LIMPIEZA DE TIENDAS LOCALES TEMPORALES
 *
 * Busca y elimina tiendas temporales (ID comenzando con "local_") cuando ya existe
 * la versión definitiva del servidor en la base de datos.
 *
 * ✅ Mejoras:
 * - Limpieza automática sin intervención manual
 * - Transacción atómica (todo o nada)
 * - Logging detallado de qué se eliminó
 * - Validación antes de eliminar
 *
 * @description
 * Lógica de limpieza:
 * 1. Buscar todas las tiendas con _id que comience con "local_"
 * 2. Para cada una, revisar su campo _id_mongoDB
 * 3. Verificar si existe una tienda con ese ID definitivo en STORES
 * 4. Si existe, eliminar la tienda temporal y sus relaciones
 *
 * @returns Promise con estadísticas de limpieza
 *
 * @example
 * const result = await cleanupLocalStores()
 * console.log(`Eliminadas ${result.deletedStores} tiendas temporales`)
 */
export async function cleanupLocalStores(
    forceDelete: boolean = false,
    storeIdsToDelete: string[] = [],
): Promise<{
    success: boolean
    deletedStores: number
    storesDeleted: string[]
}> {
    if (isWeb()) {
        return {
            success: false,
            deletedStores: 0,
            storesDeleted: [],
        }
    }

    const db = await getDb()
    const startTime = Date.now()

    console.log('🧹 Iniciando limpieza de tiendas locales temporales...')

    return db.transaction(async (txn) => {
        try {
            let storesToDelete: string[] = []

            // ✅ CASO 1: Eliminación forzada (cuando se crea online)
            if (forceDelete && storeIdsToDelete.length > 0) {
                console.log(`🗑️ Eliminación forzada de ${storeIdsToDelete.length} tiendas...`)
                storesToDelete = storeIdsToDelete
            }

            // ✅ CASO 2: Limpieza automática (sync periódico)
            else {
                const localStores = await txn.getAll<{
                    _id: string
                    _id_mongoDB: string | null
                    name: string
                }>({
                    sql: `SELECT _id, _id_mongoDB, name 
                          FROM ${SCHEDULES_STORE_NAMES.STORES} 
                          WHERE _id LIKE 'local_%'`,
                    params: [],
                })

                if (!localStores || localStores.length === 0) {
                    console.log('ℹ️ No hay tiendas locales temporales para limpiar')
                    return { success: true, deletedStores: 0, storesDeleted: [] }
                }

                console.log(`📋 Encontradas ${localStores.length} tiendas locales temporales`)

                // ✅ NUEVO: Si tiene _id_mongoDB, significa que ya se sincronizó
                // No necesitamos verificar si existe la definitiva localmente
                for (const localStore of localStores) {
                    if (!localStore._id_mongoDB) {
                        console.log(`⏭️ Tienda ${localStore._id} (${localStore.name}) aún no sincronizada, manteniendo`)
                        continue
                    }

                    // ✅ Si tiene _id_mongoDB, ya fue enviada al servidor
                    // Verificamos que los registros relacionados ya usen el ID definitivo
                    const hasDefinitiveReferences = await txn.getFirst<{ count: number }>({
                        sql: `SELECT COUNT(*) as count 
                              FROM ${SCHEDULES_STORE_NAMES.SCHEDULES_POS} 
                              WHERE store_id = ?`,
                        params: [localStore._id_mongoDB],
                    })

                    if (hasDefinitiveReferences && hasDefinitiveReferences.count > 0) {
                        console.log(`✅ Referencias actualizadas para ${localStore._id_mongoDB} (eliminando local: ${localStore._id})`)
                        storesToDelete.push(localStore._id)
                    } else {
                        console.log(`⏭️ Referencias aún no actualizadas para ${localStore._id}, manteniendo local`)
                    }
                }
            }

            if (storesToDelete.length === 0) {
                console.log('ℹ️ No hay tiendas locales para eliminar')
                return { success: true, deletedStores: 0, storesDeleted: [] }
            }

            console.log(`🗑️ Eliminando ${storesToDelete.length} tiendas temporales...`)

            // Eliminar de todas las tablas
            for (const storeId of storesToDelete) {
                await txn.run({
                    sql: `DELETE FROM ${SCHEDULES_STORE_NAMES.STORES} WHERE _id = ?`,
                    params: [storeId],
                })

                await txn.run({
                    sql: `DELETE FROM ${SCHEDULES_STORE_NAMES.SCHEDULES_POS} WHERE store_id = ?`,
                    params: [storeId],
                })

                await txn.run({
                    sql: `DELETE FROM ${SCHEDULES_STORE_NAMES.CHECKIN} WHERE store_id = ?`,
                    params: [storeId],
                })

                await txn.run({
                    sql: `DELETE FROM ${SCHEDULES_STORE_NAMES.CHECKOUT} WHERE store_id = ?`,
                    params: [storeId],
                })

                await txn.run({
                    sql: `DELETE FROM ${SCHEDULES_STORE_NAMES.SCHEDULES_ADVANCES} WHERE pos_id = ?`,
                    params: [storeId],
                })

                // ✅ NUEVO: También eliminar de STORES_PENDING_SEND si existe
                await txn.run({
                    sql: `DELETE FROM ${SCHEDULES_STORE_NAMES.STORES_PENDING_SEND} 
                          WHERE json_extract(data_match, '$.store_id') = ?`,
                    params: [storeId],
                })

                console.log(`✅ Tienda local eliminada: ${storeId}`)
            }

            const elapsed = Date.now() - startTime
            console.log(`🎉 Limpieza completada en ${elapsed}ms - ${storesToDelete.length} tiendas eliminadas`)

            return {
                success: true,
                deletedStores: storesToDelete.length,
                storesDeleted: storesToDelete,
            }
        } catch (error) {
            console.error('❌ Error en cleanupLocalStores:', {
                error: error.message,
                stack: error.stack,
            })
            throw error
        }
    })
}

/**
 * 🆕 MIGRADO DESDE schedules.database.js
 *
 * Actualiza los registros de una tienda cuando se cambia su ID
 * (típicamente cuando una tienda local obtiene su ID definitivo del servidor)
 *
 * ✅ Mejoras sobre la versión anterior:
 * - Tipado TypeScript completo
 * - Usa transacción del nuevo adapter (más eficiente)
 * - Prepared statements (mejor performance y seguridad)
 * - Manejo de errores robusto con logging detallado
 * - Soporte web + native
 * - Todas las operaciones son atómicas (rollback automático si falla alguna)
 *
 * @description
 * Actualiza en una sola transacción atómica:
 * 1. SCHEDULES_POS: store_id, campaign_status, existsInDB
 * 2. STORES: existsInDB, _id_mongoDB
 * 3. CHECKIN: store_id
 * 4. CHECKOUT: store_id
 * 5. FORMS_QUESTION_ANSWERS: store_id
 * 6. SCHEDULES_ADVANCES: DELETE registros con el ID antiguo
 *
 * @param oldStoreId - ID temporal/antiguo de la tienda
 * @param newStoreId - ID definitivo de la tienda del servidor
 * @returns Promise con resultado de la operación
 *
 * @example
 * await updateStoreRecords('temp_store_123', '507f1f77bcf86cd799439011')
 */
export async function updateStoreRecords(
    oldStoreId: string,
    newStoreId: string,
): Promise<{
    success: boolean
    updatedTables: string[]
    deletedAdvances: boolean
}> {
    if (isWeb()) {
        return {
            success: false,
            updatedTables: [],
            deletedAdvances: false,
        }
    }

    if (!oldStoreId || !newStoreId) {
        throw new Error('oldStoreId y newStoreId son requeridos')
    }

    if (oldStoreId === newStoreId) {
        console.warn('⚠️ oldStoreId y newStoreId son iguales, no se requiere actualización')
        return {
            success: true,
            updatedTables: [],
            deletedAdvances: false,
        }
    }

    const db = await getDb()
    const startTime = Date.now()

    console.log(`🔄 Iniciando actualización de Store ID: ${oldStoreId} → ${newStoreId}`)

    return db.transaction(async (txn) => {
        const updatedTables: string[] = []

        try {
            // 1. UPDATE SCHEDULES_POS
            await txn.run({
                sql: `UPDATE ${SCHEDULES_STORE_NAMES.SCHEDULES_POS} 
                      SET store_id = ?, campaign_status = ?, existsInDB = ? 
                      WHERE store_id = ?`,
                params: [newStoreId, FORM_SCHEDULE_STATUS.COMPLETED, 1, oldStoreId],
            })
            updatedTables.push('SCHEDULES_POS')
            console.log(`✅ SCHEDULES_POS actualizada: ${oldStoreId} → ${newStoreId}`)

            // 2. UPDATE STORES
            await txn.run({
                sql: `UPDATE ${SCHEDULES_STORE_NAMES.STORES}
                      SET existsInDB = ?, _id_mongoDB = ?
                      WHERE _id = ?`,
                params: [1, newStoreId, oldStoreId],
            })
            updatedTables.push('STORES')
            console.log(`✅ STORES actualizada: existsInDB=true para ${oldStoreId}`)

            // 3. UPDATE CHECKIN
            await txn.run({
                sql: `UPDATE ${SCHEDULES_STORE_NAMES.CHECKIN} 
                      SET store_id = ?
                      WHERE store_id = ?`,
                params: [newStoreId, oldStoreId],
            })
            updatedTables.push('CHECKIN')
            console.log(`✅ CHECKIN actualizada: ${oldStoreId} → ${newStoreId}`)

            // 4. UPDATE CHECKOUT
            await txn.run({
                sql: `UPDATE ${SCHEDULES_STORE_NAMES.CHECKOUT} 
                      SET store_id = ? 
                      WHERE store_id = ?`,
                params: [newStoreId, oldStoreId],
            })
            updatedTables.push('CHECKOUT')
            console.log(`✅ CHECKOUT actualizada: ${oldStoreId} → ${newStoreId}`)

            // 5. UPDATE FORMS_QUESTION_ANSWERS
            await txn.run({
                sql: `UPDATE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} 
                      SET store_id = ? 
                      WHERE store_id = ?`,
                params: [newStoreId, oldStoreId],
            })
            updatedTables.push('FORMS_QUESTION_ANSWERS')
            console.log(`✅ FORMS_QUESTION_ANSWERS actualizada: ${oldStoreId} → ${newStoreId}`)

            // 6. DELETE de SCHEDULES_ADVANCES
            // (Se eliminan en lugar de actualizar porque se regenerarán con los datos nuevos)
            const deleteResult = await txn.run({
                sql: `DELETE FROM ${SCHEDULES_STORE_NAMES.SCHEDULES_ADVANCES} 
                      WHERE pos_id = ?`,
                params: [oldStoreId],
            })

            const deletedCount = deleteResult?.changes || 0
            console.log(`✅ SCHEDULES_ADVANCES: ${deletedCount} registros eliminados para ${oldStoreId}`)

            const elapsed = Date.now() - startTime
            console.log(`🎉 Actualización completada en ${elapsed}ms - Tablas: ${updatedTables.join(', ')}`)

            return {
                success: true,
                updatedTables,
                deletedAdvances: deletedCount > 0,
            }
        } catch (error) {
            console.error('❌ Error en updateStoreRecords:', {
                oldStoreId,
                newStoreId,
                error: error.message,
                stack: error.stack,
                tablesUpdated: updatedTables,
            })
            throw error
        }
    })
}

// ============================================================================
// STORES CREATE - Funciones para gestión de campos de creación de tiendas
// ============================================================================

export interface FieldCreateStore {
    _id: string
    name: string
    title: string
    type: string
    required: boolean
    dependency?: string | null
    placeholder?: string | null
    options?: any[]
    optionsFrom?: string | null
    configure?: any
    validate_unique?: boolean
    table?: string | null
}

export interface OrganizationCreateStore {
    _id: string
    name: string
    code: string
    [key: string]: any
}

export interface CountryDataCreateStore {
    _id: string
    name: string
    prefix?: string
    geo_code?: string
    provinces: ProvinceCreateStore[]
}

export interface ProvinceCreateStore {
    _id: string
    name: string
    cities: CityCreateStore[]
}

export interface CityCreateStore {
    _id: string
    name: string
}

/**
 * @description Guarda campos de creación de tiendas en la tabla SCHEDULE_STORES_CREATE_FIELDS
 * @param fields - Array de campos a guardar
 * @returns Promise con el resultado de la operación
 */
export async function saveFieldsCreatePos(fields: FieldCreateStore[]): Promise<{ success: boolean; insertedCount: number }> {
    if (!fields || fields.length === 0) {
        console.error('saveFieldsCreatePos - No hay campos para guardar')
        throw new Error('invalid Fields')
    }

    // console.log(`🔵 saveFieldsCreatePos - Iniciando inserción de ${fields.length} campos`)

    if (isWeb()) {
        // TODO: Implementar versión web cuando sea necesario
        throw new Error('saveFieldsCreatePos web no implementado aún')
    }

    const db = await getDb()

    return await db.transaction(async (txn) => {
        let insertedCount = 0

        for (const field of fields) {
            // console.log(`🔹 Insertando campo ${insertedCount + 1}/${fields.length}:`, {
            //     _id: field._id,
            //     name: field.name,
            //     title: field.title,
            //     type: field.type,
            // })

            try {
                const result = await txn.run({
                    sql: `INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_STORES_CREATE_FIELDS} 
                        (_id, name, title, type, required, dependency, placeholder, options, optionsFrom, configure, validate_unique, table_name)
                        VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`,
                    params: [
                        field._id,
                        field.name,
                        field.title,
                        field.type,
                        field.required ? 1 : 0,
                        field.dependency || null,
                        field.placeholder || null,
                        JSON.stringify(field.options || []),
                        field.optionsFrom || null,
                        field.configure ? JSON.stringify(field.configure) : null,
                        field.validate_unique ? 1 : 0,
                        field.table || null,
                    ],
                })

                insertedCount++
                // console.log(`✅ Campo insertado (${insertedCount}/${fields.length}):`, field.name, '- changes:', result.changes)
            } catch (error) {
                console.error(`❌ Error insertando campo "${field.name}":`, error)
                console.error('Datos del campo que falló:', JSON.stringify(field, null, 2))
                throw error
            }
        }

        console.log(`✅ saveFieldsCreatePos - Todos los campos insertados correctamente (${insertedCount}/${fields.length})`)
        return { success: true, insertedCount }
    })
}

/**
 * @description Guarda campos de organización en la tabla SCHEDULE_STORES_CREATE_FIELDS_ORGANIZATIONS
 * @param fields - Array de campos a guardar
 * @returns Promise con el resultado de la operación
 */
export async function saveFieldsOrganizationCreatePos(fields: FieldCreateStore[]): Promise<{ success: boolean; insertedCount: number }> {
    if (!fields || fields.length === 0) {
        console.error('saveFieldsOrganizationCreatePos - No hay campos para guardar')
        throw new Error('invalid Fields')
    }

    console.log(`🔵 saveFieldsOrganizationCreatePos - Iniciando inserción de ${fields.length} campos`)

    if (isWeb()) {
        // TODO: Implementar versión web cuando sea necesario
        throw new Error('saveFieldsOrganizationCreatePos web no implementado aún')
    }

    const db = await getDb()

    return await db.transaction(async (txn) => {
        let insertedCount = 0

        for (const field of fields) {
            // console.log(`🔹 Insertando campo org ${insertedCount + 1}/${fields.length}:`, {
            //     _id: field._id,
            //     name: field.name,
            //     title: field.title,
            //     type: field.type,
            // })

            try {
                const result = await txn.run({
                    sql: `INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_STORES_CREATE_FIELDS_ORGANIZATIONS} 
                        (_id, name, title, type, required, dependency, placeholder, options, optionsFrom, configure, validate_unique, table_name)
                        VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`,
                    params: [
                        field._id,
                        field.name,
                        field.title,
                        field.type,
                        field.required ? 1 : 0,
                        field.dependency || null,
                        field.placeholder || null,
                        JSON.stringify(field.options || []),
                        field.optionsFrom || null,
                        field.configure ? JSON.stringify(field.configure) : null,
                        field.validate_unique ? 1 : 0,
                        field.table || null,
                    ],
                })

                insertedCount++
                // console.log(`✅ Campo org insertado (${insertedCount}/${fields.length}):`, field.name, '- changes:', result.changes)
            } catch (error) {
                console.error(`❌ Error insertando campo org "${field.name}":`, error)
                console.error('Datos del campo que falló:', JSON.stringify(field, null, 2))
                throw error
            }
        }

        console.log(`✅ saveFieldsOrganizationCreatePos - Todos los campos insertados correctamente (${insertedCount}/${fields.length})`)
        return { success: true, insertedCount }
    })
}

/**
 * @description Guarda organizaciones en la tabla SCHEDULE_STORES_ORGANIZATIONS
 * @param organizations - Array de organizaciones a guardar
 * @returns Promise con el resultado de la operación
 *
 * ✅ OPTIMIZADO: Batch insert con múltiples VALUES en una sola query (100-1000x más rápido)
 */
export async function addOrganizaciones(organizations: OrganizationCreateStore[]): Promise<{ success: boolean; insertedCount: number }> {
    if (!organizations || organizations.length === 0) {
        console.error('addOrganizaciones - No hay organizaciones para guardar')
        throw new Error('invalid Organizations')
    }

    console.log(`🔵 addOrganizaciones - Iniciando inserción de ${organizations.length} organizaciones`)

    if (isWeb()) {
        // TODO: Implementar versión web cuando sea necesario
        throw new Error('addOrganizaciones web no implementado aún')
    }

    const db = await getDb()

    return await db.transaction(async (txn) => {
        // ✅ BATCH INSERT: Una sola query con múltiples VALUES
        const placeholders = organizations.map(() => '(?, ?, ?)').join(',')
        const values = organizations.flatMap((org) => [org._id, org.name, org.code])

        const query = `INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_STORES_ORGANIZATIONS} 
            (_id, name, code)
            VALUES ${placeholders}`

        try {
            const result = await txn.run({
                sql: query,
                params: values,
            })

            console.log(`✅ addOrganizaciones - ${organizations.length} organizaciones insertadas en batch - changes:`, result.changes)
            return { success: true, insertedCount: organizations.length }
        } catch (error) {
            console.error('❌ Error en batch insert de organizaciones:', error)
            console.error('Total organizaciones:', organizations.length)
            throw error
        }
    })
}

/**
 * @description Guarda datos de país con provincias y ciudades en las tablas correspondientes
 * @param country - Datos del país a guardar
 * @returns Promise con el resultado de la operación
 *
 * ✅ OPTIMIZADO: Batch inserts para provincias y ciudades (100-1000x más rápido)
 */
export async function saveCountryData(country: CountryDataCreateStore): Promise<{ success: boolean; provincesCount: number; citiesCount: number }> {
    if (!country || !country._id) {
        console.error('saveCountryData - Datos de país inválidos')
        throw new Error('invalid Country data')
    }

    console.log(`🔵 saveCountryData - Guardando país: ${country.name}`)

    if (isWeb()) {
        // TODO: Implementar versión web cuando sea necesario
        throw new Error('saveCountryData web no implementado aún')
    }

    const db = await getDb()

    return await db.transaction(async (txn) => {
        // 1. Guardar país (1 solo registro)
        const countryResult = await txn.run({
            sql: `INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_STORES_CREATE_COUNTRIES} 
                (_id, prefix, name, geo_code)
                VALUES (?, ?, ?, ?)`,
            params: [country._id, country.prefix || '', country.name, country.geo_code || ''],
        })

        console.log(`✅ País guardado: ${country.name} - changes:`, countryResult.changes)

        if (!country.provinces || country.provinces.length === 0) {
            console.log('⚠️ No hay provincias para guardar')
            return { success: true, provincesCount: 0, citiesCount: 0 }
        }

        // 2. ✅ BATCH INSERT de provincias
        const provincePlaceholders = country.provinces.map(() => '(?, ?, ?)').join(',')
        const provinceValues = country.provinces.flatMap((p) => [p._id, p.name, country._id])

        const provinceQuery = `INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_STORES_CREATE_PROVINCES} 
            (_id, name, country_id)
            VALUES ${provincePlaceholders}`

        await txn.run({
            sql: provinceQuery,
            params: provinceValues,
        })

        console.log(`✅ ${country.provinces.length} provincias guardadas en batch`)

        // 3. ✅ BATCH INSERT de ciudades en chunks (para evitar límite de SQL variables)
        const allCities: Array<{ _id: string; name: string; province_id: string; country_id: string }> = []

        for (const province of country.provinces) {
            if (province.cities && province.cities.length > 0) {
                for (const city of province.cities) {
                    allCities.push({
                        _id: city._id,
                        name: city.name,
                        province_id: province._id,
                        country_id: country._id,
                    })
                }
            }
        }

        if (allCities.length > 0) {
            // Límite de SQL: 999 variables / 4 columnas = ~240 registros seguros por batch
            const CHUNK_SIZE = 200
            const chunks = Math.ceil(allCities.length / CHUNK_SIZE)

            for (let i = 0; i < chunks; i++) {
                const start = i * CHUNK_SIZE
                const end = Math.min(start + CHUNK_SIZE, allCities.length)
                const chunk = allCities.slice(start, end)

                const cityPlaceholders = chunk.map(() => '(?, ?, ?, ?)').join(',')
                const cityValues = chunk.flatMap((c) => [c._id, c.name, c.province_id, c.country_id])

                const cityQuery = `INSERT OR REPLACE INTO ${TABLE_NAME.SCHEDULE_STORES_CREATE_CITIES} 
                    (_id, name, province_id, country_id)
                    VALUES ${cityPlaceholders}`

                await txn.run({
                    sql: cityQuery,
                    params: cityValues,
                })

                // console.log(`✅ Chunk ${i + 1}/${chunks}: ${chunk.length} ciudades guardadas (${end}/${allCities.length} total)`)
            }

            console.log(`✅ ${allCities.length} ciudades guardadas en ${chunks} batch(es)`)
        }

        console.log(`✅ saveCountryData completo - País: ${country.name}, Provincias: ${country.provinces.length}, Ciudades: ${allCities.length}`)
        return { success: true, provincesCount: country.provinces.length, citiesCount: allCities.length }
    })
}

// ============================================================================
// 🔍 BÚSQUEDA DE TIENDAS
// ============================================================================

/**
 * Interface para el resultado de búsqueda de tiendas
 */
export interface StoreSearchResult {
    _id: string
    schedule_id: string
    name: string
    code: string
    address: string
    lat?: number
    lng?: number
    forms: any[]
    forms_relevant?: any[]
    forms_featured?: any[]
    campaign_status: number
    segment: string
    cluster: string
}

/**
 * 🆕 MIGRADO Y OPTIMIZADO DESDE schedules.database.js
 *
 * Busca tiendas por texto (nombre, código o dirección) dentro de un schedule
 *
 * ✅ Mejoras sobre la versión anterior:
 * - FIX: Orden correcto de parámetros SQL (antes estaba mal con unshift)
 * - TypeScript con tipos estrictos
 * - Usa el nuevo adapter (mejor performance)
 * - Prepared statements nativos
 * - Logging detallado para debugging
 * - Parsing automático de JSON (forms)
 * - Manejo robusto de errores
 * - Soporte web + native
 *
 * @description
 * Lógica de búsqueda:
 * 1. CTE (filtered_stores): Pre-filtra STORES por name/code/address
 * 2. JOIN con SCHEDULES_POS para obtener relación schedule-store
 * 3. LEFT JOIN con SCHEDULES_ADVANCES para obtener progreso
 * 4. Retorna stores con su campaign_status y forms
 *
 * Query optimizada con:
 * - CTE para evitar escaneo completo de STORES
 * - Subquery para obtener último advance (MAX date_modified)
 * - Índices en store_id, schedule_id (asumiendo que existen)
 *
 * @param scheduleId - ID del schedule
 * @param searchText - Texto a buscar (case-insensitive, busca parcial)
 * @returns Promise con array de tiendas encontradas
 *
 * @example
 * const stores = await searchStoresByText('schedule_123', 'oxxo')
 * console.log(`Encontradas ${stores.length} tiendas`)
 */
export async function searchStoresByText(scheduleId: string, searchText: string): Promise<StoreSearchResult[]> {
    console.log('🔍 searchStoresByText - Buscando:', { scheduleId, searchText })

    if (isWeb()) {
        console.warn('⚠️ searchStoresByText no soportado en web')
        return []
    }

    const db = await getDb()

    return await db.transaction(async (txn) => {
        try {
            // ⚠️ FIX CRÍTICO: Orden correcto de parámetros
            // La query espera: searchText (x3), scheduleId
            // La versión anterior hacía unshift incorrecto

            const searchPattern = `%${searchText.trim()}%`
            const params = [
                searchPattern, // name LIKE ?
                searchPattern, // code LIKE ?
                searchPattern, // address LIKE ?
                scheduleId, // schedule_id = ?
            ]

            const query = `
                WITH filtered_stores AS (
                    SELECT _id, name, code, address, lat, lng, segment, cluster 
                    FROM ${TABLE_NAME.SCHEDULE_STORES}
                    WHERE LOWER(name) LIKE LOWER(?) 
                       OR LOWER(code) LIKE LOWER(?) 
                       OR LOWER(address) LIKE LOWER(?)
                )
                SELECT 
                    pos.store_id AS _id,
                    pos.schedule_id,
                    pos.forms,
                    pos.forms_relevant,
                    pos.forms_featured,
                    fs.name, 
                    fs.code, 
                    fs.address, 
                    fs.lat,
                    fs.lng,
                    fs.segment, 
                    fs.cluster,
                    adv.forms AS forms_advances,
                    COALESCE(adv.status, 0) AS campaign_status
                FROM ${TABLE_NAME.SCHEDULE_SCHEDULES_POS} AS pos 
                INNER JOIN filtered_stores AS fs ON pos.store_id = fs._id
                LEFT JOIN (
                    SELECT adv.pos_id, adv.schedule_id, adv.forms, adv.status 
                    FROM ${TABLE_NAME.SCHEDULE_ADVANCES} AS adv
                    INNER JOIN (
                        SELECT pos_id, schedule_id, MAX(date_modified) AS latest_date 
                        FROM ${TABLE_NAME.SCHEDULE_ADVANCES}
                        GROUP BY pos_id, schedule_id
                    ) AS latest_adv
                    ON adv.pos_id = latest_adv.pos_id 
                       AND adv.schedule_id = latest_adv.schedule_id 
                       AND adv.date_modified = latest_adv.latest_date
                ) AS adv
                ON pos.store_id = adv.pos_id AND pos.schedule_id = adv.schedule_id 
                WHERE pos.schedule_id = ?
                ORDER BY fs.name ASC;
            `

            console.log('🔍 Ejecutando query con params:', params)

            const result = await txn.getAll<any>({
                sql: query,
                params: params,
            })

            console.log(`🔍 Resultados encontrados: ${result.length} tiendas`)

            // Parsear JSON y mapear a la estructura esperada
            const stores: StoreSearchResult[] = result.map((row: any) => {
                let forms: any[] = []
                try {
                    if (row.forms && typeof row.forms === 'string') {
                        forms = JSON.parse(row.forms)
                    } else if (Array.isArray(row.forms)) {
                        forms = row.forms
                    }
                } catch (e) {
                    console.warn('⚠️ Error parsing forms JSON:', e)
                    forms = []
                }

                let forms_relevant: any[] = []
                try {
                    if (row.forms_relevant && typeof row.forms_relevant === 'string') {
                        forms_relevant = JSON.parse(row.forms_relevant)
                    } else if (Array.isArray(row.forms_relevant)) {
                        forms_relevant = row.forms_relevant
                    }
                } catch (e) {
                    forms_relevant = []
                }

                let forms_featured: any[] = []
                try {
                    if (row.forms_featured && typeof row.forms_featured === 'string') {
                        forms_featured = JSON.parse(row.forms_featured)
                    } else if (Array.isArray(row.forms_featured)) {
                        forms_featured = row.forms_featured
                    }
                } catch (e) {
                    forms_featured = []
                }

                return {
                    _id: row._id,
                    schedule_id: row.schedule_id,
                    name: row.name || '',
                    code: row.code || '',
                    address: row.address || '',
                    lat: row.lat,
                    lng: row.lng,
                    forms: forms,
                    forms_relevant: forms_relevant,
                    forms_featured: forms_featured,
                    campaign_status: row.campaign_status ?? 0,
                    segment: row.segment || '',
                    cluster: row.cluster || '',
                }
            })

            console.log(`✅ searchStoresByText completo - ${stores.length} tiendas retornadas`)
            return stores
        } catch (error) {
            console.error('❌ Error en searchStoresByText:', error)
            throw error
        }
    })
}
